// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bar Owner Dashboard Styles */
.bar-owner-dashboard {
  padding: 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 1.8rem;
  padding: 1.2rem 0;
}

.section-subtitle {
  color: var(--text-gray);
  font-size: 1.1rem;
  margin-top: 0.5rem;
}

.content-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.placeholder-card {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 3rem;
  text-align: center;
  max-width: 500px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.placeholder-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.placeholder-card h2 {
  color: var(--text-white);
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.placeholder-card p {
  color: var(--text-gray);
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Tab Selector */
.tab-selector {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 2rem;
  padding: 0;
  border-bottom: 2px solid var(--border-gray);
  width: 100%;
}

.tab-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.25rem 2rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--text-gray);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  top: 2px;
  flex: 1;
}

.tab-button:hover {
  color: var(--text-white);
  background: var(--bg-gray);
}

.tab-button.active {
  color: var(--text-white);
  border-bottom-color: var(--primary-red);
  background: var(--bg-gray-light);
}

.tab-icon {
  font-size: 1.2rem;
}

.tab-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tab-content {
  padding: 2rem 0;
  animation: fadeIn 0.3s ease;
}

/* Remove top padding for financials pages */
.tab-content:has(.financials-overall),
.tab-content:has(.financials-by-artist) {
  padding-top: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Artists Content */
.artists-content {
  padding: 0 1rem;
}

/* Search Section */
.search-section {
  margin-bottom: 2rem;
}

.search-bar-container {
  position: relative;
  margin-bottom: 1.5rem;
}

.search-input {
  width: 100%;
  padding: 1rem 3rem 1rem 1rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
}

.search-input::placeholder {
  color: var(--text-gray);
}

.search-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: var(--text-gray);
  pointer-events: none;
}

/* Alphabet Filter */
.alphabet-filter {
  margin-bottom: 1rem;
}

.alphabet-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

.alphabet-btn {
  padding: 0.5rem 0.75rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 40px;
}

.alphabet-btn:hover {
  background: var(--bg-gray-light);
  color: var(--text-white);
  border-color: var(--primary-red);
}

.alphabet-btn.active {
  background: var(--primary-red);
  color: var(--text-white);
  border-color: var(--primary-red);
}

/* Results Info */
.results-info {
  margin-bottom: 1.5rem;
  text-align: center;
}

.results-count {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
}

/* Artists Grid */
.artists-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  padding-bottom: 2rem;
}

.artist-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.artist-card:hover {
  transform: translateY(-4px);
  border-color: var(--primary-red);
  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.2);
}

.artist-photo {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: var(--bg-gray-light);
}

.artist-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.artist-card:hover .artist-photo img {
  transform: scale(1.05);
}

.artist-info {
  padding: 1.5rem;
}

.artist-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-white);
  margin-bottom: 0.5rem;
}

.artist-location,
.artist-genre {
  color: var(--text-gray);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.artist-details {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-gray);
}

.artist-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.rating-stars {
  color: #ffd700;
  font-size: 1rem;
}

.rating-value {
  color: var(--text-white);
  font-weight: 600;
  font-size: 0.9rem;
}

.artist-price {
  color: var(--primary-red);
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.artist-availability {
  color: var(--text-gray);
  font-size: 0.85rem;
  font-style: italic;
}

/* No Results */
.no-results {
  grid-column: 1 / -1;
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-gray);
}

.no-results-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.no-results h3 {
  color: var(--text-white);
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}

.no-results p {
  font-size: 1rem;
  line-height: 1.6;
}

/* Filters Section */
.filters-section {
  margin-bottom: 1rem;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-label {
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select {
  padding: 0.75rem 1rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.filter-select:focus {
  outline: none;
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
}

.filter-select option {
  background: var(--bg-gray);
  color: var(--text-white);
  padding: 0.5rem;
}

/* Filter Actions */
.filter-actions {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.clear-filters-btn {
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: 2px solid var(--primary-red);
  border-radius: 6px;
  color: var(--primary-red);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clear-filters-btn:hover {
  background: var(--primary-red);
  color: var(--text-white);
}

/* Show Details Section */
.show-details-section,
.artist-source-section,
.mile-range-section {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
}

.section-title {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.show-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-label {
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.date-input,
.time-input {
  padding: 0.75rem 1rem;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.date-input:focus,
.time-input:focus {
  outline: none;
  border-color: var(--primary-red);
}

.date-input::-webkit-calendar-picker-indicator,
.time-input::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

/* Artist Source Section */
.artist-source-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.3s ease;
}

.radio-label:hover {
  color: var(--primary-red);
}

.radio-input {
  display: none;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-gray);
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
}

.radio-input:checked + .radio-custom {
  border-color: var(--primary-red);
}

.radio-input:checked + .radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background: var(--primary-red);
  border-radius: 50%;
}

.radio-description {
  color: var(--text-gray);
  font-size: 0.85rem;
  margin-left: 2.75rem;
  margin-top: -0.25rem;
}

/* Cover Badge */
.cover-specialty {
  margin-top: 0.5rem;
}

.cover-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(45deg, var(--primary-red), #ff6b6b);
  color: var(--text-white);
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Artists Content */
.artists-content {
  padding: 1rem;
}

.artists-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

/* Calendar Section */
.calendar-section {
  position: relative;
  margin-bottom: 3rem;
  min-height: 420px;
}

.calendar-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(12, 12, 14, 0.6);
  backdrop-filter: blur(2px);
  z-index: 5;
  border-radius: 16px;
  pointer-events: all;
}

.calendar-loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: rgba(24, 24, 28, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

.calendar-loading-spinner {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--primary-red);
  border-right-color: rgba(255, 255, 255, 0.35);
  animation: calendarSpinner 0.9s linear infinite;
}

.calendar-loading-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

@keyframes calendarSpinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.calendar-nav {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 0;
}

.calendar-nav-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  width: 100%;
}

.calendar-nav-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.add-show-btn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: var(--primary-red);
  border-color: var(--primary-red);
  color: var(--text-white);
  font-weight: 600;
  white-space: nowrap;
}

.add-show-btn:hover {
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.add-show-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  padding: 1.5rem;
}

.add-show-modal {
  position: relative;
  isolation: isolate;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  width: 100%;
  max-width: 520px;
  box-shadow: var(--shadow-dark), var(--shadow-red);
  overflow: hidden;
  animation: addShowModalSlideIn 0.25s ease;
}

.add-show-modal-busy-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(12, 12, 14, 0.85);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  pointer-events: all;
}

@keyframes addShowModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.add-show-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid var(--border-gray);
  position: relative;
}

.add-show-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
}

.add-show-modal-header h2 {
  margin: 0;
  color: var(--text-white);
  font-size: 1.35rem;
  font-weight: 600;
}

.add-show-modal-close {
  background: transparent;
  border: none;
  color: var(--text-gray);
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.add-show-modal-close:hover {
  background: var(--bg-gray);
  color: var(--primary-red);
}

.add-show-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.75rem;
}

.add-show-form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
}

.add-show-form-row--single {
  grid-template-columns: 1fr;
}

.add-show-label {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  color: var(--text-gray);
  font-size: 0.95rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-show-input {
  padding: 0.75rem 1rem;
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.add-show-input:focus {
  outline: none;
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
  box-shadow: var(--shadow-red);
}

.add-show-input option {
  background: var(--bg-card);
  color: var(--text-white);
}

.add-show-custom-times-row {
  margin: -0.75rem 0 0;
}

.add-show-custom-times-toggle {
  display: inline;
  padding: 0;
  border: none;
  background: none;
  color: var(--primary-red);
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  text-align: left;
}

.add-show-custom-times-toggle:hover:not(:disabled) {
  color: #ff6b6b;
}

.add-show-custom-times-toggle:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-show-split-pay {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.add-show-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.add-show-toggle-label {
  color: var(--text-white);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.9rem;
}

.add-show-member-splits {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 0.25rem;
}

.add-show-split-total {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.add-show-split-total--ok {
  color: var(--text-gray);
}

.add-show-split-total--warn {
  color: #fca5a5;
}

.add-show-helper {
  margin: -0.5rem 0 0.5rem;
  color: var(--primary-red);
  font-size: 0.85rem;
  line-height: 1.4;
  text-align: left;
}

.add-show-error {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.35);
  color: #fca5a5;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
}

.add-show-recurring {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  padding: 0.5rem 0;
}

.add-show-recurring-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-left: 2px solid var(--border-gray);
  padding-left: 0.75rem;
  margin-left: 0.1rem;
}

.add-show-recurring-field {
  width: 100%;
  max-width: none;
  text-transform: uppercase;
}

.add-show-recurring-field .add-show-input {
  margin-top: 0.35rem;
}

.add-show-weekday-heading {
  display: block;
  color: var(--text-white);
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.add-show-weekday-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.add-show-weekday-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.55rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-gray);
  transition: border-color 0.2s ease, color 0.2s ease;
}

.add-show-weekday-chip:hover {
  border-color: var(--border-red);
  color: var(--text-white);
}

.add-show-weekday-chip input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-red);
  cursor: pointer;
  margin: 0;
}

.add-show-weekday-chip--on {
  border-color: var(--primary-red);
  color: var(--text-white);
}

.add-show-recurrence-summary {
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-gray);
  line-height: 1.45;
}

.add-show-recurrence-summary--warn {
  color: #fca5a5;
}

.add-show-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.add-show-cancel-btn,
.add-show-submit-btn {
  padding: 0.75rem 1.75rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-show-cancel-btn {
  background: transparent;
  border: 1px solid var(--border-gray);
  color: var(--text-gray);
}

.add-show-cancel-btn:hover {
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.add-show-submit-btn {
  background: var(--primary-red);
  border: none;
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.add-show-submit-btn:hover {
  background: #dc2626;
}

.add-show-cancel-btn:disabled,
.add-show-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
.calendar-month-display {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  flex-shrink: 0;
  min-width: 250px;
}

.nav-btn-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.month-btn {
  padding: 0.75rem 2rem;
}

.nav-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  background: var(--bg-card);
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.nav-btn:hover {
  border-color: var(--border-red);
  color: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.week-btn {
  background: var(--bg-gray);
}

.day-btn {
  background: var(--bg-card);
}

/* Week Calendar (for Dashboard) */
.week-calendar {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin: 0;
}

.week-calendar .calendar-day {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 0;
  flex: 1;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 500px;
}

.week-calendar .calendar-day:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.week-calendar .calendar-day.today {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.week-calendar .calendar-day.today::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.week-calendar .day-header {
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-gray);
}

.week-calendar .day-name {
  color: var(--text-gray);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.25rem;
}

.week-calendar .day-number {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
}

.week-calendar .day-shows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  flex: 1;
}

.week-calendar .show-slot {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.3s ease;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.week-calendar .show-slot.has-show {
  background: var(--bg-gray);
  border-color: rgba(250, 82, 82, 0.45);
  box-shadow: 0 8px 20px rgba(250, 82, 82, 0.12);
}

.week-calendar .show-slot.no-show {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.08);
  opacity: 0.75;
}

.week-calendar .show-slot.no-show .slot-title,
.week-calendar .show-slot.no-show .slot-subtitle,
.week-calendar .show-slot.no-show .slot-content {
  color: rgba(255, 255, 255, 0.7);
}

.week-calendar .show-slot:hover {
  border-color: var(--border-red);
  background: var(--bg-gray-light);
}

.week-calendar .slot-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-gray);
}

.week-calendar .slot-title {
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.week-calendar .slot-subtitle {
  color: var(--text-gray);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.week-calendar .slot-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.week-calendar .slot-content.empty {
  opacity: 0.5;
}

/* Pending show indicators (inner content only; outer matches .show-slot.has-show) */
.slot-content.booked.pending {
  border-style: dashed;
  opacity: 0.8;
  border-color: rgba(250, 82, 82, 0.5);
}

.slot-content.booked.pending:hover {
  opacity: 1;
  border-color: rgba(250, 82, 82, 0.8);
}

.pending-badge {
  display: inline-block;
  background: rgba(250, 82, 82, 0.2);
  color: var(--primary-red);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.artist-name.pending {
  opacity: 0.8;
}

.week-calendar .no-show-text {
  color: var(--text-muted);
  font-size: 0.8rem;
  font-style: italic;
  text-align: center;
}

/* Weekday Headers (for Month Calendar) */
.calendar-weekday-headers {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0 0.25rem;
}

.weekday-header {
  text-align: center;
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.5rem;
}

/* Month Calendar Grid */
.month-calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.5rem;
  width: 100%;
  margin: 0;
}

.calendar-day-cell {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  padding: 0.5rem;
  min-height: 120px;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.calendar-day-cell:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
  transform: translateY(-2px);
}

.calendar-day-cell.today {
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
  box-shadow: var(--shadow-red);
}

.calendar-day-cell.today::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-red);
  border-radius: 8px 8px 0 0;
}

.calendar-day-cell.other-month {
  opacity: 0.3;
  cursor: default;
}

.calendar-day-cell.other-month:hover {
  border-color: var(--border-gray);
  box-shadow: none;
  transform: none;
}

.calendar-day-cell .day-header {
  padding: 0;
  text-align: right;
  border-bottom: none;
  background: transparent;
  margin-bottom: 0.25rem;
}

.calendar-day-cell .day-number {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 700;
}

.calendar-day-cell .day-shows {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  padding: 0;
}

/* Bar owner month grid: compact indicators (shown only on mobile via media queries) */
.calendar-day-mobile-summary {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  flex-wrap: wrap;
  margin-top: 0.15rem;
}

.calendar-day-has-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--primary-red);
  flex-shrink: 0;
  box-shadow: 0 0 6px rgba(255, 0, 51, 0.35);
}

.calendar-day-show-count {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-white);
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.calendar-day-pending-indicator {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 210, 120, 1);
  flex-shrink: 0;
  box-shadow:
    0 0 0 1px rgba(255, 170, 60, 0.65),
    0 0 8px rgba(255, 200, 80, 0.35);
}

/* Compact Show Slots (for Month Calendar) */
.show-slot-compact {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 4px;
  padding: 0.3rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.3rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.show-slot-compact:hover {
  background: var(--bg-gray-light);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
  transform: translateY(-1px);
}

.show-slot-compact.has-show {
  border-color: rgba(250, 82, 82, 0.45);
  box-shadow: 0 6px 16px rgba(250, 82, 82, 0.12);
}

.show-slot-compact.no-show {
  background: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.08);
  opacity: 0.75;
}

.show-slot-compact.no-show .artist-name {
  color: rgba(255, 255, 255, 0.65);
  font-style: italic;
}

.show-slot-compact:focus,
.show-slot-compact:focus-visible {
  outline: none;
  border-color: var(--border-red);
  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.25);
}

.slot-compact-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  width: 100%;
}

.slot-label-compact {
  color: var(--text-white);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.65rem;
  letter-spacing: 0.5px;
}

.slot-time-compact {
  font-size: 0.65rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}

.artist-name {
  color: var(--text-white);
  font-weight: 600;
  font-size: 0.72rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Show Card Modal */
.show-card-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px);
  z-index: 1100;
  padding: 1.5rem;
}

.show-card-modal {
  width: 100%;
  max-width: 560px;
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  animation: showCardModalFade 0.25s ease;
  display: flex;
  flex-direction: column;
}

.show-card-modal-form {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@keyframes showCardModalFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.show-card-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
}

.show-card-modal-header-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.show-card-modal-message,
.show-card-modal-close {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.75);
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 1.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.show-card-modal-message:hover,
.show-card-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.show-card-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
}

.show-card-modal-header-content h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-white);
  letter-spacing: 0.5px;
}

.show-card-modal-venue {
  margin: 0.4rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  letter-spacing: 0.4px;
}

.show-card-modal-close {
  font-size: 1.75rem;
}

.show-card-modal-body {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  position: relative;
}

.show-card-modal-body--loading {
  min-height: 280px;
  align-items: center;
  justify-content: center;
}

.show-card-modal-artist {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.show-card-modal-image-wrapper {
  width: 110px;
  height: 110px;
  border-radius: 18px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}

.show-card-modal-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.show-card-modal-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.show-card-modal-info-item .label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 0.35rem;
}

.show-card-modal-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  color: var(--text-white);
  font-size: 0.95rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.show-card-modal-input:focus {
  outline: none;
  border-color: rgba(250, 82, 82, 0.6);
  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.15);
}

.show-card-modal-input[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.show-card-modal-time-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.show-card-modal-time-row .show-card-modal-info-item {
  flex: 1;
  min-width: 140px;
}

.show-card-modal-info-item .value {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}

.show-card-modal-statistics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.show-card-modal-stat {
  padding: 1.1rem 1.25rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.show-card-modal-input-wrapper {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  overflow: hidden;
}

.currency-prefix {
  padding: 0.6rem 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
  background: rgba(255, 255, 255, 0.04);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.show-card-modal-input-wrapper .show-card-modal-input {
  border: none;
  border-radius: 0;
  background: transparent;
  padding-left: 0.6rem;
}

.show-card-modal-input-wrapper .show-card-modal-input:focus {
  box-shadow: none;
}

.value--muted {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 500;
}

.show-card-modal-stat .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.4px;
}

.show-card-modal-stat .value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-white);
}

.show-card-modal-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.75);
}

.show-card-modal-loading--centered {
  min-height: 160px;
  justify-content: center;
}

.show-card-modal-loading .spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--primary-red);
  animation: showCardSpinner 0.75s linear infinite;
}

@keyframes showCardSpinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.show-card-modal-error {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(250, 82, 82, 0.4);
  color: rgba(255, 155, 155, 0.9);
  background: rgba(250, 82, 82, 0.15);
}

.show-card-modal-success {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(74, 222, 128, 0.35);
  color: rgba(187, 247, 208, 0.9);
  background: rgba(34, 197, 94, 0.15);
}

.show-card-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1.25rem 1.75rem 1.5rem 1.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  gap: 0.75rem;
  background: transparent;
}

.show-card-modal-primary-btn,
.show-card-modal-secondary-btn,
.show-card-modal-danger-btn {
  border: none;
  padding: 0.7rem 1.8rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    background-color 0.2s ease;
}

.show-card-modal-primary-btn {
  background: var(--primary-red);
  color: var(--text-white);
}

.show-card-modal-primary-btn:hover:enabled {
  box-shadow: var(--shadow-red);
  transform: translateY(-1px);
}

.show-card-modal-secondary-btn {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}

.show-card-modal-secondary-btn:hover:enabled {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.show-card-modal-danger-btn {
  background: rgba(250, 82, 82, 0.12);
  color: rgba(255, 135, 135, 0.9);
  border: 1px solid rgba(250, 82, 82, 0.35);
}

.show-card-modal-danger-btn:hover:enabled {
  background: rgba(250, 82, 82, 0.2);
  color: rgba(255, 155, 155, 0.95);
  box-shadow: 0 12px 24px rgba(250, 82, 82, 0.25);
  transform: translateY(-1px);
}

.show-card-modal-primary-btn:disabled,
.show-card-modal-secondary-btn:disabled,
.show-card-modal-danger-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Confirm Modal */
.confirm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.78);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 1.5rem;
}

.confirm-modal {
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  width: 100%;
  max-width: 420px;
  overflow: hidden;
  animation: showCardModalFade 0.2s ease;
  display: flex;
  flex-direction: column;
}

.confirm-modal-header {
  padding: 1.25rem 1.75rem 0.75rem;
}

.confirm-modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: var(--text-white);
}

.confirm-modal-body {
  padding: 0 1.75rem 1.5rem;
}

.confirm-modal-body p {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.6;
}

.confirm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.75rem 1.5rem;
}

.confirm-modal-secondary-btn,
.confirm-modal-danger-btn {
  border: none;
  padding: 0.65rem 1.6rem;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.confirm-modal-secondary-btn {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}

.confirm-modal-secondary-btn:hover:enabled {
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
  transform: translateY(-1px);
}

.confirm-modal-danger-btn {
  background: rgba(250, 82, 82, 0.2);
  color: rgba(255, 155, 155, 0.95);
  border: 1px solid rgba(250, 82, 82, 0.4);
}

.confirm-modal-danger-btn:hover:enabled {
  box-shadow: 0 12px 26px rgba(250, 82, 82, 0.25);
  transform: translateY(-1px);
}

.confirm-modal-danger-btn:disabled,
.confirm-modal-secondary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Financial Section */
.financial-section {
  margin-top: 3rem;
}

.section-title {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.comparison-section-box {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 1.25rem;
  margin-bottom: 3rem;
  margin-top: 0;
  transition: all 0.3s ease;
  position: relative;
}

.comparison-section-box:first-of-type {
  margin-top: 3rem;
}

.comparison-section-box:last-child {
  margin-bottom: 0;
}

.comparison-section-box:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.comparison-section-title {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}

.section-info-icon[data-tooltip]::before {
  width: 320px;
  font-size: 0.9rem;
}

.financial-grid {
  display: flex;
  gap: 1.5rem;
  width: 100%;
  margin: 0 0 3rem 0;
}

.financial-card {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.financial-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.financial-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.financial-card h3 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
}

.date-range {
  color: var(--text-gray);
  font-size: 0.85rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 1rem;
  text-transform: none;
  letter-spacing: normal;
}

.info-icon {
  font-size: 0.9rem;
  cursor: help;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  position: relative;
  display: inline-block;
}

.card-info-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.section-info-icon {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 10;
  font-size: 1rem;
}

.info-icon:hover {
  opacity: 1;
}

.info-icon[data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
  white-space: normal;
  width: 280px;
  max-width: 90vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  line-height: 1.5;
  text-align: left;
}

.card-info-icon[data-tooltip]::before {
  bottom: auto;
  top: 100%;
  left: auto;
  right: 0;
  transform: none;
  margin-bottom: 0;
  margin-top: 0.5rem;
  width: 280px;
}

.section-info-icon[data-tooltip]::before {
  bottom: auto;
  top: 100%;
  left: auto;
  right: 0;
  transform: none;
  margin-bottom: 0;
  margin-top: 0.5rem;
  width: 320px;
  font-size: 0.9rem;
}

.info-icon[data-tooltip]:hover::before {
  opacity: 1;
  pointer-events: auto;
}

.info-icon[data-tooltip]::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.25rem;
  border: 6px solid transparent;
  border-top-color: var(--border-gray);
  z-index: 1001;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.card-info-icon[data-tooltip]::after,
.section-info-icon[data-tooltip]::after {
  bottom: auto;
  top: 100%;
  left: auto;
  right: 1rem;
  transform: none;
  margin-bottom: 0;
  margin-top: 0.25rem;
  border-top-color: transparent;
  border-bottom-color: var(--border-gray);
}

.info-icon[data-tooltip]:hover::after {
  opacity: 1;
  pointer-events: auto;
}

.earnings-amount {
  color: var(--primary-red);
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.earnings-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.earnings-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: auto;
  flex: 1;
  justify-content: flex-start;
}

.time-slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
}

.time-slot:last-child {
  border-bottom: none;
}

.time-slot-divider {
  height: 1px;
  background: var(--border-gray);
  margin: 0.75rem 0;
  width: 100%;
}

.time-slot.total {
  border-top: 2px solid var(--primary-red);
  padding-top: 0.75rem;
  margin-top: 0.5rem;
}

.slot-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.slot-amount {
  color: var(--primary-red);
  font-size: 1.1rem;
  font-weight: 600;
}

.time-slot.total .slot-amount {
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

/* Financial Overview Specific Styles */
.slot-amount.expense {
  color: #f87171; /* Red */
  text-shadow: 0 0 10px rgba(248, 113, 113, 0.3);
}

.slot-amount.sales {
  color: #4ade80; /* Green */
  text-shadow: 0 0 10px rgba(74, 222, 128, 0.3);
}

.slot-amount.profit-positive {
  color: #4ade80; /* Green */
  text-shadow: 0 0 10px rgba(74, 222, 128, 0.3);
}

.slot-amount.profit-negative {
  color: #f87171; /* Red */
  text-shadow: 0 0 10px rgba(248, 113, 113, 0.3);
}

/* Financials Overall */
.financials-overall {
  padding: 0 1rem 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

/* By Artist Financials */
.financials-by-artist {
  padding: 0 1rem 2rem 1rem;
  max-width: 100%;
  margin: 0 auto;
}

.artist-controls {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
}

.mode-toggle {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.mode-toggle-btn {
  padding: 0.75rem 1.5rem;
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mode-toggle-btn:hover {
  background: var(--bg-gray-light);
  border-color: var(--border-red);
}

.mode-toggle-btn.active {
  background: var(--primary-red);
  border-color: var(--primary-red);
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.artist-selectors {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.artist-selector {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
}

.artist-selector label {
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.artist-dropdown {
  padding: 0.75rem 1rem;
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.artist-dropdown:hover {
  border-color: var(--border-red);
}

.artist-dropdown:focus {
  outline: none;
  border-color: var(--primary-red);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.artist-dropdown option {
  background: var(--bg-card);
  color: var(--text-white);
}

.artist-dropdown option:disabled {
  color: var(--text-gray);
  font-style: italic;
}

/* Financials Page (Dedicated Page) */
.financials-overall-tab {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.financials-row-container {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 20px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.financials-row-container:hover {
  border-color: var(--border-red);
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);
}

.comparison-row-title {
  color: var(--primary-red);
  font-size: 1.3rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid var(--primary-red);
  text-shadow: 0 0 10px rgba(220, 38, 38, 0.3);
}

.financials-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  width: 100%;
}

.financials-detail-card {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex: 1 1 calc(33.333% - 1rem);
  max-width: calc(33.333% - 1rem);
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.financials-detail-card.wide {
  flex: 1 1 100%;
  max-width: 100%;
}

.financials-detail-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.financials-detail-card.difference::before {
  background: linear-gradient(90deg, #10b981, #34d399);
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);
}

.financials-detail-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.financials-detail-card.difference:hover {
  border-color: #10b981;
  box-shadow: 0 0 15px rgba(16, 185, 129, 0.3);
}

.financials-detail-card h3 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
}

.financials-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: auto;
  flex: 1;
  justify-content: flex-start;
}

.financials-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
}

.financials-item:last-child {
  border-bottom: none;
}

.financials-item.total {
  border-top: 2px solid var(--primary-red);
  padding-top: 0.75rem;
  margin-top: 0.5rem;
}

.financials-item.artist-name-item {
  border-bottom: 2px solid var(--primary-red);
  padding-bottom: 0.75rem;
  margin-bottom: 0.5rem;
  justify-content: center;
}

.artist-name-label {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  width: 100%;
}

.financials-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.financials-amount {
  color: var(--primary-red);
  font-size: 1.1rem;
  font-weight: 600;
}

.financials-item.total .financials-amount {
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.financials-amount.positive {
  color: #10b981;
  text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);
}

.financials-amount.negative {
  color: #ef4444;
  text-shadow: 0 0 10px rgba(239, 68, 68, 0.3);
}

/* Financials Summary Cards */
.financials-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.summary-card {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.summary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.summary-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.summary-card h4 {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}

.summary-amount {
  color: var(--primary-red);
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.summary-change {
  font-size: 0.9rem;
  font-weight: 600;
}

.summary-change.positive {
  color: #10b981;
}

.summary-change.negative {
  color: #ef4444;
}

/* Financials Periods */
.financials-periods {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.financials-period-card {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 20px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.financials-period-card:hover {
  border-color: var(--border-red);
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);
}

.period-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border-gray);
}

.period-header h3 {
  color: var(--primary-red);
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 0.75rem;
  text-shadow: 0 0 10px rgba(220, 38, 38, 0.3);
}

.period-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.total-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.total-amount {
  color: var(--primary-red);
  font-size: 1.5rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.change-indicator {
  font-size: 1rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
}

.change-indicator.positive {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.change-indicator.negative {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.period-comparison {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.period-data {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}

.period-data h4 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-gray);
}

.period-data.difference h4 {
  color: var(--primary-red);
}

.slot-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
}

.slot-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
  gap: 0.5rem;
}

.slot-item:last-child {
  border-bottom: none;
}

.slot-item.total {
  border-top: 2px solid var(--primary-red);
  padding-top: 0.75rem;
  margin-top: 0.5rem;
}

.slot-label {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.slot-value {
  color: var(--primary-red);
  font-size: 1.1rem;
  font-weight: 600;
  text-align: right;
}

.slot-item.total .slot-value {
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

.slot-value.positive {
  color: #10b981;
  text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);
}

.slot-value.negative {
  color: #ef4444;
  text-shadow: 0 0 10px rgba(239, 68, 68, 0.3);
}

.change-badge {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  white-space: nowrap;
}

.change-badge.positive {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.change-badge.negative {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.no-data-message {
  text-align: center;
  padding: 3rem 2rem;
  color: var(--text-gray);
}

.no-data-message p {
  font-size: 1.1rem;
  margin: 0;
}

.error-message {
  text-align: center;
  padding: 3rem 2rem;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 12px;
}

.error-message p {
  font-size: 1.1rem;
  margin: 0;
}

/* By Artists Tab */
.financials-by-artists-tab {
  padding: 0;
}

.financials-single-artist,
.financials-compare-artists {
  padding: 0;
}

.artist-selection-section {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  transition: all 0.3s ease;
}

.artist-selection-section:hover {
  border-color: var(--border-red);
}

.financials-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 2rem;
}

.placeholder-message {
  text-align: center;
  max-width: 500px;
}

.placeholder-icon {
  font-size: 4rem;
  display: block;
  margin-bottom: 1rem;
}

.placeholder-message h3 {
  color: var(--text-white);
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.placeholder-message p {
  color: var(--text-gray);
  font-size: 1rem;
  line-height: 1.6;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  box-shadow: var(--shadow-dark), var(--shadow-red);
  z-index: 1001;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease;
}

/* Modal scrollbar styling */
.modal-container::-webkit-scrollbar {
  width: 8px;
}

.modal-container::-webkit-scrollbar-track {
  background: var(--bg-gray);
  border-radius: 4px;
}

.modal-container::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 4px;
}

.modal-container::-webkit-scrollbar-thumb:hover {
  background: var(--primary-red);
  box-shadow: var(--shadow-red);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -45%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid var(--border-gray);
  position: relative;
}

.modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  border-radius: 16px 16px 0 0;
}

.modal-title {
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.modal-close-btn {
  background: transparent;
  border: none;
  color: var(--text-gray);
  font-size: 2rem;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  background: var(--bg-gray);
  color: var(--primary-red);
}

.modal-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.modal-show-card {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.modal-show-card:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.modal-show-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-gray-light);
}

.modal-show-header h3 {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.modal-show-time {
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 500;
}

.modal-show-details {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  color: var(--text-gray);
  font-size: 0.95rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
}

.status-booked {
  color: var(--primary-red);
  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);
}

/* Tablet Responsive Styles */
@media (max-width: 1024px) {
  .financials-detail-card {
    flex: 1 1 calc(50% - 0.75rem);
    max-width: calc(50% - 0.75rem);
  }

  .financials-detail-card.wide {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  .bar-owner-dashboard {
    padding: 1rem 0.5rem;
  }

  /* Tab Selector Mobile */
  .tab-selector {
    padding: 0;
    justify-content: space-evenly;
  }

  .tab-button {
    padding: 1rem 1rem;
    font-size: 0.9rem;
    flex: 1;
  }

  .tab-icon {
    font-size: 1rem;
  }

  /* Artists Content Mobile */
  .artists-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }

  .artist-photo {
    height: 150px;
  }

  .artist-info {
    padding: 1rem;
  }

  .search-input {
    padding: 0.75rem 2.5rem 0.75rem 0.75rem;
    font-size: 0.9rem;
  }

  .alphabet-buttons {
    gap: 0.25rem;
  }

  .alphabet-btn {
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
    min-width: 35px;
  }

  /* Filters Mobile */
  .filters-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
  }

  .filter-select {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
  }

  .clear-filters-btn {
    padding: 0.6rem 1.25rem;
    font-size: 0.85rem;
  }

  /* FindCovers Mobile */
  .show-details-section,
  .artist-source-section,
  .mile-range-section {
    padding: 1rem;
  }

  .show-details-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .artist-source-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .tab-content {
    padding: 1.5rem 0;
  }

  .artists-content {
    padding: 0.5rem;
  }

  .artists-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .calendar-nav-right {
    display: none;
  }

  /* Bar owner surfaces only: stack Add Show above nav; keep nav controls in one row like artist dashboard */
  .bar-owner-dashboard .calendar-nav {
    gap: 1rem;
    flex-direction: column;
  }

  /* Month on first row (full width); back / forward controls in two equal columns below */
  .bar-owner-dashboard .calendar-nav-content {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    gap: 0.65rem 0.75rem;
  }

  .bar-owner-dashboard .calendar-month-display {
    order: -1;
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
    letter-spacing: 0.12em;
    margin: 0;
    font-size: 1.15rem;
  }

  .bar-owner-dashboard .calendar-nav-content > .nav-btn-group {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.35rem;
    justify-content: center;
    align-items: center;
  }

  .bar-owner-dashboard .calendar-nav-content .nav-btn {
    padding: 0.55rem 0.45rem;
    font-size: 0.72rem;
    letter-spacing: 0.03em;
    flex: 1 1 auto;
    min-width: 0;
    text-transform: uppercase;
  }

  .bar-owner-dashboard .calendar-nav-content .nav-btn.month-btn {
    flex: 1 1 auto;
    padding: 0.55rem 0.85rem;
    font-size: 0.78rem;
  }

  .bar-owner-dashboard .add-show-btn {
    position: static;
    transform: none;
    width: 100%;
  }

  .add-show-form-row {
    grid-template-columns: 1fr;
  }

  .add-show-form {
    padding: 1.5rem;
  }

  .add-show-recurring {
    align-items: stretch;
  }

  .add-show-toggle-row {
    flex-wrap: wrap;
  }

  .add-show-weekday-row {
    gap: 0.4rem;
  }

  .add-show-weekday-chip {
    flex: 1 1 calc(14.28% - 0.35rem);
    min-width: 3.25rem;
    justify-content: center;
  }

  .calendar-month-display {
    font-size: 1.2rem;
    min-width: auto;
  }

  .month-btn {
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
  }

  /* Week view (dashboard only): stack days vertically — full-width rows, no horizontal strip */
  .bar-owner-dashboard .week-calendar {
    flex-direction: column;
    gap: 0.75rem;
    overflow-x: visible;
    width: 100%;
  }

  .bar-owner-dashboard .week-calendar .calendar-day {
    width: 100%;
    min-width: unset;
    flex: none;
    min-height: auto;
  }

  .bar-owner-dashboard .week-calendar .day-header {
    padding: 0.75rem;
  }

  .bar-owner-dashboard .week-calendar .day-number {
    font-size: 1.25rem;
  }

  .bar-owner-dashboard .week-calendar .day-shows {
    padding: 0.5rem;
  }

  .bar-owner-dashboard .week-calendar .show-slot {
    padding: 0.5rem;
  }

  .bar-owner-dashboard .week-calendar .slot-title {
    font-size: 0.8rem;
  }

  .bar-owner-dashboard .week-calendar .slot-subtitle {
    font-size: 0.65rem;
  }

  .bar-owner-dashboard .week-calendar .no-show-text {
    font-size: 0.75rem;
  }

  /* Month Calendar Mobile Styles */
  .weekday-header {
    font-size: 0.75rem;
    padding: 0.25rem;
  }

  .month-calendar {
    gap: 0.25rem;
  }

  .calendar-day-cell {
    min-height: 100px;
    padding: 0.25rem;
  }

  .calendar-day-cell .day-number {
    font-size: 0.9rem;
  }

  .calendar-day-cell .day-shows {
    gap: 0.2rem;
  }

  .show-slot-compact {
    padding: 0.2rem 0.35rem;
  }

  .slot-label-compact {
    font-size: 0.6rem;
  }

  .artist-name {
    font-size: 0.65rem;
  }

  /* Bar owner full-month calendar: compact grid + badges; hide inline slots (tap cell → modal) */
  .bar-owner-dashboard .month-calendar {
    gap: 0.35rem;
  }

  .bar-owner-dashboard .calendar-day-cell {
    min-height: 3.35rem;
    padding: 0.35rem 0.28rem;
    justify-content: flex-start;
  }

  .bar-owner-dashboard .calendar-day-cell .day-header {
    margin-bottom: 0;
  }

  .bar-owner-dashboard .calendar-day-cell .day-number {
    font-size: 0.85rem;
  }

  .bar-owner-dashboard .calendar-day-cell .day-shows {
    display: none;
  }

  .bar-owner-dashboard .calendar-day-mobile-summary {
    display: flex;
    margin-top: 0.2rem;
  }

  .bar-owner-dashboard .calendar-day-cell[role="button"]:focus-visible {
    outline: 2px solid var(--primary-red);
    outline-offset: 2px;
  }

  .bar-owner-dashboard .calendar-day-show-count {
    font-size: 0.68rem;
  }

  .financial-grid {
    flex-direction: column;
    gap: 1rem;
  }

  .financial-card {
    padding: 1.5rem;
  }

  .earnings-breakdown {
    gap: 0.5rem;
  }

  .slot-amount {
    font-size: 1rem;
  }

  .time-slot.total .slot-amount {
    font-size: 1.2rem;
  }

  /* Financials Page Mobile */
  .financials-row-container {
    padding: 1.5rem;
  }

  .financials-row {
    flex-direction: column;
    gap: 1rem;
  }

  .financials-detail-card {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 1.5rem;
    min-height: auto;
  }

  .card-subtitle {
    font-size: 0.85rem;
  }

  .financials-breakdown {
    gap: 0.5rem;
  }

  .financials-amount {
    font-size: 1rem;
  }

  .financials-item.total .financials-amount {
    font-size: 1.2rem;
  }

  /* New Financials Components Mobile */
  .financials-summary-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .summary-card {
    padding: 1.25rem;
  }

  .summary-amount {
    font-size: 1.5rem;
  }

  .financials-period-card {
    padding: 1.5rem;
  }

  .period-header h3 {
    font-size: 1.1rem;
  }

  .period-comparison {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .period-data {
    padding: 1.25rem;
  }

  .total-amount {
    font-size: 1.2rem;
  }

  .artist-name-label {
    font-size: 1rem;
  }

  .artist-selection-section {
    padding: 1rem;
  }

  .placeholder-message h3 {
    font-size: 1.2rem;
  }

  .placeholder-message p {
    font-size: 0.9rem;
  }

  .placeholder-icon {
    font-size: 3rem;
  }

  /* Modal Responsive */
  .modal-container {
    width: 95%;
    max-height: 85vh;
  }

  /* Bar owner Calendar day-detail modal: respect visible viewport on mobile Safari */
  .bar-owner-dashboard .modal-container.calendar-day-detail-modal {
    max-height: 80vh;
    max-height: 80dvh;
    width: min(640px, 95vw);
  }

  .bar-owner-dashboard .calendar-day-detail-modal .modal-content {
    margin: 0 auto;
    width: 100%;
    max-width: 640px;
    align-items: center;
  }

  .bar-owner-dashboard .calendar-day-detail-modal .modal-show-card {
    width: 100%;
    max-width: 560px;
  }

  .modal-header {
    padding: 1.5rem;
  }

  .modal-title {
    font-size: 1.2rem;
  }

  .modal-content {
    padding: 1.5rem;
    gap: 1rem;
  }

  .modal-show-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .modal-show-details {
    padding: 1rem;
  }

  /* Bar admin Management: prevent wide tables/lists from forcing horizontal page scroll */
  .bar-owner-dashboard .management-content {
    min-width: 0;
    max-width: 100%;
  }

  .bar-owner-dashboard .management-section {
    min-width: 0;
  }
}

@media (max-width: 480px) {
  /* Tab Selector Extra Small Mobile */
  .tab-selector {
    padding: 0;
  }

  .tab-button {
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
    flex-direction: column;
    gap: 0.25rem;
  }

  .tab-icon {
    font-size: 0.9rem;
  }

  /* Artists Content Extra Small Mobile */
  .artists-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .artist-photo {
    height: 120px;
  }

  .artist-info {
    padding: 0.75rem;
  }

  .artist-name {
    font-size: 1rem;
  }

  .search-input {
    padding: 0.5rem 2rem 0.5rem 0.5rem;
    font-size: 0.85rem;
  }

  .alphabet-buttons {
    gap: 0.2rem;
  }

  .alphabet-btn {
    padding: 0.3rem 0.4rem;
    font-size: 0.75rem;
    min-width: 30px;
  }

  /* Filters Extra Small Mobile */
  .filters-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .filter-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }

  .filter-label {
    font-size: 0.8rem;
  }

  .clear-filters-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  /* FindCovers Extra Small Mobile */
  .show-details-section,
  .artist-source-section,
  .mile-range-section {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }

  .date-input,
  .time-input {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
  }

  .radio-label {
    font-size: 0.9rem;
  }

  .radio-description {
    font-size: 0.8rem;
  }

  .cover-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.6rem;
  }

  .tab-label {
    font-size: 0.85rem;
  }

  .tab-content {
    padding: 1rem 0;
  }

  .artists-content {
    padding: 0.25rem;
  }

  .bar-owner-dashboard .calendar-nav {
    flex-direction: column;
    gap: 0.75rem;
  }

  .bar-owner-dashboard .calendar-nav-content {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    gap: 0.5rem 0.6rem;
  }

  .bar-owner-dashboard .calendar-month-display {
    order: -1;
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
    letter-spacing: 0.1em;
    font-size: 1rem;
    margin: 0;
  }

  .bar-owner-dashboard .calendar-nav-content > .nav-btn-group {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.3rem;
    justify-content: center;
    align-items: center;
  }

  .bar-owner-dashboard .calendar-nav-content .nav-btn {
    padding: 0.5rem 0.35rem;
    font-size: 0.68rem;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
    text-transform: uppercase;
  }

  .bar-owner-dashboard .calendar-nav-content .nav-btn.month-btn {
    padding: 0.5rem 0.65rem;
    font-size: 0.75rem;
  }

  .bar-owner-dashboard .add-show-btn {
    width: 100%;
  }

  .month-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  /* Week view (dashboard): stacked days, full width */
  .bar-owner-dashboard .week-calendar {
    flex-direction: column;
    gap: 0.5rem;
    overflow-x: visible;
    width: 100%;
    padding-bottom: 0.5rem;
  }

  .bar-owner-dashboard .week-calendar .calendar-day {
    width: 100%;
    min-width: unset;
    flex: none;
    min-height: auto;
  }

  .bar-owner-dashboard .week-calendar .day-header {
    padding: 0.5rem;
  }

  .bar-owner-dashboard .week-calendar .day-name {
    font-size: 0.65rem;
  }

  .bar-owner-dashboard .week-calendar .day-number {
    font-size: 1rem;
  }

  .bar-owner-dashboard .week-calendar .day-shows {
    padding: 0.5rem;
    gap: 0.25rem;
  }

  .bar-owner-dashboard .week-calendar .show-slot {
    padding: 0.5rem;
  }

  .bar-owner-dashboard .week-calendar .slot-title {
    font-size: 0.75rem;
  }

  .bar-owner-dashboard .week-calendar .slot-subtitle {
    font-size: 0.6rem;
  }

  .bar-owner-dashboard .week-calendar .no-show-text {
    font-size: 0.7rem;
  }

  /* Month Calendar Extra Small Mobile */
  .weekday-header {
    font-size: 0.65rem;
    padding: 0.2rem;
  }

  .month-calendar {
    gap: 0.2rem;
  }

  .calendar-day-cell {
    min-height: 85px;
    padding: 0.2rem;
  }

  .calendar-day-cell .day-number {
    font-size: 0.8rem;
  }

  .calendar-day-cell .day-shows {
    gap: 0.15rem;
  }

  .show-slot-compact {
    padding: 0.15rem 0.3rem;
  }

  .slot-label-compact {
    font-size: 0.55rem;
  }

  .artist-name {
    font-size: 0.6rem;
  }

  .bar-owner-dashboard .month-calendar {
    gap: 0.28rem;
  }

  .bar-owner-dashboard .calendar-day-cell {
    min-height: 3rem;
    padding: 0.28rem 0.22rem;
  }

  .bar-owner-dashboard .calendar-day-cell .day-number {
    font-size: 0.78rem;
  }

  .bar-owner-dashboard .calendar-day-show-count {
    font-size: 0.62rem;
  }

  .bar-owner-dashboard .calendar-day-has-dot,
  .bar-owner-dashboard .calendar-day-pending-indicator {
    width: 6px;
    height: 6px;
  }

  .financial-grid {
    flex-direction: column;
  }

  .earnings-breakdown {
    gap: 0.5rem;
  }

  .time-slot {
    padding: 0.25rem 0;
  }

  .slot-label {
    font-size: 0.8rem;
  }

  .slot-amount {
    font-size: 0.9rem;
  }

  .time-slot.total .slot-amount {
    font-size: 1.1rem;
  }

  /* Financials Page Extra Small Mobile */
  .financials-overall-tab {
    gap: 1.5rem;
  }

  .financials-row-container {
    padding: 1rem;
  }

  .financials-row {
    flex-direction: column;
    gap: 0.75rem;
  }

  .financials-detail-card {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 1rem;
    min-height: auto;
  }

  .financials-detail-card h3 {
    font-size: 1rem;
  }

  .card-subtitle {
    font-size: 0.8rem;
  }

  .financials-breakdown {
    gap: 0.5rem;
  }

  .financials-item {
    padding: 0.25rem 0;
  }

  .financials-label {
    font-size: 0.8rem;
  }

  .artist-name-label {
    font-size: 0.95rem;
  }

  .financials-amount {
    font-size: 0.9rem;
  }

  .financials-item.total .financials-amount {
    font-size: 1.1rem;
  }

  /* New Financials Components Extra Small Mobile */
  .financials-summary-cards {
    gap: 0.75rem;
  }

  .summary-card {
    padding: 1rem;
  }

  .summary-card h4 {
    font-size: 0.85rem;
  }

  .summary-amount {
    font-size: 1.25rem;
  }

  .summary-change {
    font-size: 0.8rem;
  }

  .financials-period-card {
    padding: 1rem;
  }

  .period-header {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
  }

  .period-header h3 {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }

  .period-summary {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .total-label {
    font-size: 0.8rem;
  }

  .total-amount {
    font-size: 1.1rem;
  }

  .change-indicator {
    font-size: 0.85rem;
    padding: 0.2rem 0.5rem;
  }

  .period-comparison {
    gap: 0.75rem;
  }

  .period-data {
    padding: 1rem;
  }

  .period-data h4 {
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
  }

  .slot-breakdown {
    gap: 0.5rem;
  }

  .slot-item {
    padding: 0.4rem 0;
  }

  .slot-label {
    font-size: 0.8rem;
  }

  .slot-value {
    font-size: 0.95rem;
  }

  .slot-item.total .slot-value {
    font-size: 1.1rem;
  }

  .change-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }

  .artist-selection-section {
    padding: 0.75rem;
  }

  .placeholder-message h3 {
    font-size: 1rem;
  }

  .placeholder-message p {
    font-size: 0.85rem;
  }

  .placeholder-icon {
    font-size: 2.5rem;
  }

  .financials-placeholder {
    min-height: 300px;
  }

  /* Modal Extra Small */
  .modal-header {
    padding: 1rem;
  }

  .modal-title {
    font-size: 1rem;
  }

  .modal-content {
    padding: 1rem;
  }

  .modal-show-header h3 {
    font-size: 1rem;
  }

  .modal-show-time {
    font-size: 0.8rem;
  }
}

/* ============================================ */
/* SETTINGS SPECIFIC STYLES */
/* ============================================ */

.settings-content {
  padding: 0 1rem;
}

.settings-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.settings-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.settings-card:hover {
  border-color: var(--border-red);
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);
}

.settings-card.danger-card {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.settings-card.danger-card:hover {
  border-color: #dc2626;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-gray);
}

.card-header h3 {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.settings-input,
.settings-select,
.settings-textarea {
  padding: 0.75rem 1rem;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.settings-input:focus,
.settings-select:focus,
.settings-textarea:focus {
  outline: none;
  border-color: var(--primary-red);
  background: var(--bg-card);
}

.settings-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.settings-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.settings-select {
  cursor: pointer;
}

.settings-select option {
  background: var(--bg-gray);
  color: var(--text-white);
}

.edit-btn,
.action-btn,
.save-btn,
.submit-btn {
  padding: 0.75rem 1.5rem;
  background: var(--primary-red);
  border: none;
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.edit-btn:hover,
.action-btn:hover,
.save-btn:hover,
.submit-btn:hover {
  background: #dc2626;
  box-shadow: var(--shadow-red);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.danger-btn {
  padding: 0.75rem 1.5rem;
  background: #ef4444;
  border: none;
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.danger-btn:hover {
  background: #dc2626;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.cancel-btn {
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-gray);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cancel-btn:hover {
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.password-info {
  color: var(--text-gray);
  line-height: 1.6;
}

.password-info p {
  margin-bottom: 0.5rem;
}

.text-muted {
  color: var(--text-gray);
  font-size: 0.9rem;
}

/* Danger Zone Styles */
.danger-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.danger-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
}

.danger-info h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.danger-info p {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin: 0;
}

/* Notification Preferences Styles */
.preferences-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.preference-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.preference-item:hover {
  border-color: var(--border-red);
  background: var(--bg-card);
}

.preference-info h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.preference-info p {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin: 0;
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--border-gray);
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: var(--primary-red);
}

input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

/* Support Form Styles */
.support-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.help-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.help-item {
  padding: 1rem;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s ease;
}

.help-item:hover {
  border-color: var(--border-red);
  background: var(--bg-card);
}

.help-item h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.help-item p {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.help-link {
  color: var(--primary-red);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.help-link:hover {
  color: #dc2626;
  text-decoration: underline;
}

/* Privacy & Security Styles */
.privacy-content,
.rights-content,
.cookie-content,
.contact-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  color: var(--text-gray);
  line-height: 1.6;
}

.privacy-item {
  padding: 1rem;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
}

.privacy-item h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.privacy-item p {
  color: var(--text-gray);
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

.right-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  gap: 1rem;
}

.right-info {
  flex: 1;
}

.right-info h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.right-info p {
  color: var(--text-gray);
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

.right-item .action-btn {
  flex-shrink: 0;
}

.cookie-content ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.cookie-content li {
  margin-bottom: 0.5rem;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
}

.contact-item {
  color: var(--text-white);
  font-size: 0.9rem;
}

.contact-item strong {
  color: var(--primary-red);
  margin-right: 0.5rem;
}

/* Modal Actions for Settings */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.modal-content ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
  color: var(--text-gray);
}

.modal-content li {
  margin-bottom: 0.5rem;
}

/* Responsive Styles for Settings */
@media (max-width: 768px) {
  .settings-content {
    padding: 0 0.5rem;
  }

  .settings-card {
    padding: 1.5rem;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .danger-item,
  .right-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .help-links {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column;
  }

  .edit-btn,
  .action-btn,
  .save-btn,
  .submit-btn,
  .danger-btn,
  .cancel-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .settings-card {
    padding: 1rem;
  }

  .card-header h3 {
    font-size: 1rem;
  }

  .settings-input,
  .settings-select,
  .settings-textarea {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
  }

  .edit-btn,
  .action-btn,
  .save-btn,
  .submit-btn,
  .danger-btn,
  .cancel-btn {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }

  .preference-item {
    padding: 0.75rem;
  }

  .preference-info h4 {
    font-size: 0.9rem;
  }

  .preference-info p {
    font-size: 0.85rem;
  }

  .help-item {
    padding: 0.75rem;
  }

  .help-item h4 {
    font-size: 0.9rem;
  }

  .help-item p {
    font-size: 0.85rem;
  }
}

/* ============================================ */
/* MANAGEMENT SPECIFIC STYLES */
/* ============================================ */

.management-content {
  padding: 0 1rem;
}

.management-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.management-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
}

.add-btn,
.add-slot-btn {
  padding: 0.75rem 1.5rem;
  background: var(--primary-red);
  border: none;
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-btn:hover,
.add-slot-btn:hover {
  background: #dc2626;
  box-shadow: var(--shadow-red);
}

/* Bar Cards Grid */
.bars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

/* Artist cards (Find / My / Covers): narrower columns, taller photo, tighter name band */
.bars-grid.bars-grid--artists {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.bar-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.bar-card:hover {
  border-color: var(--border-red);
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);
}

.bar-card-photos {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: var(--bg-gray-light);
}

.bar-card-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bar-card-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
}

.bar-card.bar-card--artist {
  min-width: 0;
}

.bar-card.bar-card--artist .bar-card-photos {
  height: 240px;
}

.bar-card.bar-card--artist .bar-card-content {
  padding: 0.65rem 1.5rem;
  min-width: 0;
  overflow: hidden;
}

.bar-card.bar-card--artist .bar-card-name {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bar-card-content {
  padding: 1.5rem;
}

.bar-card-name {
  color: var(--text-white);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.bar-card-address {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.bar-card-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-gray);
}

.bar-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bar-detail-label {
  color: var(--text-gray);
  font-size: 0.85rem;
  font-weight: 500;
}

.bar-detail-value {
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 600;
}

/* Bar Detail Modal: match Edit Bar modal, prevent horizontal scroll */
.bar-detail-modal {
  min-width: 0;
}

.bar-detail-modal .bar-modal-body,
.bar-detail-modal.groups-modal-body {
  overflow-x: hidden;
  min-width: 0;
}

.bar-detail-modal .groups-modal-photo-wrapper {
  width: 180px;
  height: 180px;
  flex-shrink: 0;
  min-width: 180px;
}

.bar-detail-modal .groups-modal-field-value {
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}

.bar-detail-time-slots-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.bar-detail-time-slot-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.bar-detail-slot-name {
  font-weight: 600;
  color: var(--text-white);
  font-size: 0.95rem;
}

.bar-detail-slot-times {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

.bar-card-actions {
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-gray);
}

.bar-card-actions .edit-btn,
.bar-card-actions .danger-btn {
  flex: 1;
}

.no-bars-message,
.no-data-message,
.no-selection-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-gray);
}

.no-bars-icon,
.no-data-icon,
.no-selection-icon {
  font-size: 4rem;
  display: block;
  margin-bottom: 1rem;
}

.no-bars-message h3,
.no-data-message h3,
.no-selection-message h3 {
  color: var(--text-white);
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

/* Bar admin: no venues assigned (shared BarOwnerDashboard) */
.bar-admin-dashboard-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: min(55vh, 480px);
  padding: 2rem 1.5rem;
  max-width: 28rem;
  margin: 0 auto;
}

.bar-admin-dashboard-empty h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--text-white);
  line-height: 1.4;
}

.bar-admin-dashboard-empty p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

.bar-admin-dashboard-empty p + p {
  margin-top: 0.75rem;
}

.bar-admin-dashboard-email {
  font-weight: 600;
  word-break: break-word;
  color: var(--text-white) !important;
}

/* Photo Upload Styles */
.photo-upload-section {
  margin: 1.5rem 0;
}

.photo-upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.use-default-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  border: 2px solid var(--primary-red);
  border-radius: 6px;
  color: var(--primary-red);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.use-default-btn:hover {
  background: var(--primary-red);
  color: white;
}

.photo-upload-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 0.5rem;
}

.photo-upload-item {
  position: relative;
  width: 100%;
  padding-top: 75%;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 8px;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
}

.photo-upload-item:active {
  cursor: grabbing;
}

.photo-upload-item img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.photo-remove-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 30px;
  height: 30px;
  background: rgba(239, 68, 68, 0.9);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 2;
}

.photo-remove-btn:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.photo-upload-placeholder {
  width: 100%;
  padding-top: 75%;
  position: relative;
  background: var(--bg-gray-light);
  border: 2px dashed var(--border-gray);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.photo-upload-placeholder:hover {
  border-color: var(--primary-red);
  background: var(--bg-card);
}

.photo-upload-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-gray);
}

.upload-icon {
  font-size: 2rem;
}

.photo-upload-hint {
  color: var(--text-gray);
  font-size: 0.8rem;
  margin-top: 0.5rem;
  font-style: italic;
}

.photo-upload-count {
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-left: auto;
}

.photo-upload-error {
  margin-top: 0.5rem;
}

.photo-upload-loading-bar-wrap {
  width: 100%;
  margin-bottom: 0.75rem;
  background: var(--bg-gray);
  border-radius: 4px;
  overflow: hidden;
}

.photo-upload-loading-bar {
  height: 6px;
  background: var(--primary-red);
  transition: width 0.2s ease;
}

.photo-upload-loading-text {
  color: var(--text-gray);
  font-size: 0.85rem;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.photo-upload-drag-handle {
  position: absolute;
  bottom: 4px;
  left: 4px;
  z-index: 3;
  cursor: grab;
  color: var(--text-white);
  font-size: 0.75rem;
  padding: 4px 6px;
  min-width: 24px;
  min-height: 24px;
  touch-action: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}

.photo-upload-drag-handle:active {
  cursor: grabbing;
}

.photo-upload-primary-badge {
  position: absolute;
  top: 4px;
  left: 4px;
  background: var(--primary-red);
  color: var(--text-white);
  font-size: 0.65rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  z-index: 2;
}

.photo-upload-rejected-badge {
  position: absolute;
  top: 4px;
  left: 4px;
  background: #7f1d1d;
  color: var(--text-white);
  font-size: 0.65rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  z-index: 2;
}

.photo-upload-item-dragging {
  opacity: 0.7;
}

/* Full-screen photo upload progress overlay */
.photo-upload-progress-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: var(--bg-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.photo-upload-progress-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  max-width: 90vw;
}

.photo-upload-progress-overlay-spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--border-gray);
  border-top-color: var(--primary-red);
  border-radius: 50%;
  animation: photo-upload-progress-spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes photo-upload-progress-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.photo-upload-progress-overlay-title {
  color: var(--text-white);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.photo-upload-progress-overlay-count {
  color: var(--text-gray);
  font-size: 1rem;
  margin: 0;
}

.photo-upload-progress-overlay-bar {
  display: flex;
  gap: 4px;
  width: 100%;
  max-width: 320px;
  min-height: 12px;
}

.photo-upload-progress-segment {
  flex: 1;
  background: var(--bg-gray);
  border-radius: 4px;
  transition: background 0.2s ease;
}

.photo-upload-progress-segment.segment-done,
.photo-upload-progress-segment.segment-success {
  background: var(--primary-red);
}

.photo-upload-progress-segment.segment-rejected {
  background: #b91c1c;
}

.photo-upload-progress-overlay-message {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
}

.photo-upload-progress-overlay-cancel {
  margin-top: 0.5rem;
  padding: 0.5rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-white);
  background: transparent;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  cursor: pointer;
}

.photo-upload-progress-overlay-cancel:hover {
  background: var(--bg-gray);
  border-color: var(--text-gray);
}

/* Bar Form Styles */
.bar-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Time Slot Styles */
.bar-selector-section {
  margin-bottom: 2rem;
}

.bar-selector {
  width: 100%;
  max-width: 400px;
}

.time-slots-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin: 2rem 0;
}

.time-slot-item {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.time-slot-item:hover {
  border-color: var(--border-red);
}

.time-slot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-gray);
}

.time-slot-header h4 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.remove-slot-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  border: 2px solid #ef4444;
  border-radius: 6px;
  color: #ef4444;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.remove-slot-btn:hover {
  background: #ef4444;
  color: white;
}

.time-slot-form {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1rem;
}

.time-slots-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 2rem 0;
}

.time-slots-info {
  background: rgba(220, 38, 38, 0.1);
  border: 1px solid rgba(220, 38, 38, 0.3);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 2rem;
}

.time-slots-info .info-text {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.6;
}

/* Management Grid Layout (for admins tab) */
.management-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.management-col-left,
.management-col-right {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Admin List Styles */
.admin-list-section,
.pending-invites-section,
.invite-admin-form-section {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
}

/* Invite Admin - User Found container */
.invite-admin-user-found {
  margin-bottom: 20px;
  padding: 15px;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
}

.invite-admin-user-found-title {
  margin: 0 0 0.75rem 0;
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
}

.invite-admin-user-found-details {
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  color: var(--text-white);
}

.invite-admin-user-found-label {
  font-weight: 600;
}

.invite-admin-user-found-status {
  margin: 0.75rem 0 0;
  padding: 8px 12px;
  border-radius: 6px;
}

.invite-admin-user-found-status--valid {
  background: rgba(16, 185, 129, 0.2);
  border: 1px solid rgba(16, 185, 129, 0.4);
  color: #34d399;
}

.invite-admin-user-found-status--self,
.invite-admin-user-found-status--wrong_role,
.invite-admin-user-found-status--already_member,
.invite-admin-user-found-status--pending {
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #fbbf24;
}

.admin-bar-group,
.artists-bar-group {
  margin-bottom: 2rem;
}

.admin-bar-header,
.artists-bar-header,
.pending-invites-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid var(--border-gray);
}

.admin-bar-header h3,
.artists-bar-header h3,
.pending-invites-header h3 {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.admin-count,
.artist-count,
.invite-count {
  background: var(--primary-red);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
}

.admins-list,
.invites-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.admin-item,
.invite-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-gray-light);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.admin-item:hover,
.invite-item:hover {
  border-color: var(--border-red);
}

.invite-item.expiring-soon {
  border-color: #f59e0b;
  background: rgba(245, 158, 11, 0.05);
}

.admin-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--primary-red);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 600;
  flex-shrink: 0;
}

.admin-info {
  flex: 1;
}

.admin-name {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.admin-email {
  color: var(--text-gray);
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.admin-date {
  color: var(--text-gray);
  font-size: 0.75rem;
}

.admin-actions {
  display: flex;
  gap: 0.5rem;
}

.no-admins-message,
.no-invites-message,
.no-artists-message {
  text-align: center;
  padding: 2rem;
  color: var(--text-gray);
}

/* Invite Styles */
.invite-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.invite-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.invite-icon {
  font-size: 1.5rem;
}

.invite-email {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.invite-bar {
  color: var(--text-gray);
  font-size: 0.85rem;
}

.invite-meta {
  display: flex;
  gap: 1rem;
}

.invite-date,
.invite-expiry {
  color: var(--text-gray);
  font-size: 0.75rem;
}

.invite-expiry.expiring {
  color: #f59e0b;
  font-weight: 600;
}

.invite-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* Invite Form Styles */
.form-header {
  margin-bottom: 1.5rem;
}

.form-header h3 {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-header p {
  color: var(--text-gray);
  font-size: 0.9rem;
}

.invite-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input-hint {
  color: var(--text-gray);
  font-size: 0.8rem;
  margin-top: 0.25rem;
  font-style: italic;
}

.invite-info-box {
  margin-top: 1.5rem;
  padding: 1rem;
  background: rgba(220, 38, 38, 0.05);
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 8px;
}

.invite-info-box h4 {
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.invite-info-box p,
.invite-info-box ul {
  color: var(--text-gray);
  font-size: 0.85rem;
  line-height: 1.6;
  margin: 0.5rem 0;
}

.invite-info-box ul {
  padding-left: 1.5rem;
}

/* Bar Select Styles */
.bar-select-actions {
  display: flex;
  gap: 0.75rem;
}

.bar-select-btn {
  padding: 0.5rem 1rem;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bar-select-btn:hover:not(:disabled) {
  background: var(--bg-card);
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.bar-select-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bar-select-list {
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  padding: 0.75rem;
  background: var(--bg-gray-light);
}

.bar-select-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 6px;
  background: transparent;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
  user-select: none;
  -webkit-user-select: none;
}

.bar-select-item:last-child {
  margin-bottom: 0;
}

.bar-select-item:hover {
  background: var(--bg-card);
}

.bar-select-item.selected {
  background: rgba(255, 0, 51, 0.1);
  border: 1px solid rgba(255, 0, 51, 0.3);
}

.bar-select-item.selected:hover {
  background: rgba(255, 0, 51, 0.15);
  border-color: rgba(255, 0, 51, 0.5);
}

.bar-select-item--cancelling {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}

.bar-select-checkbox {
  margin-right: 0.75rem;
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--primary-red);
  flex-shrink: 0;
}

.bar-select-checkbox:checked {
  accent-color: var(--primary-red);
}

.bar-select-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.bar-select-name {
  font-weight: 600;
  color: var(--text-white);
  font-size: 0.95rem;
}

.bar-select-address {
  font-size: 0.8rem;
  color: var(--text-gray);
}

/* Artists Grid */
.artists-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
}

.stat-card:hover {
  border-color: var(--border-red);
}

.stat-icon {
  font-size: 2.5rem;
}

.stat-info h4 {
  color: var(--text-gray);
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

.stat-value {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
}

.artists-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.artist-management-card {
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.artist-management-card:hover {
  border-color: var(--border-red);
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);
}

.artist-card-photo {
  width: 100%;
  height: 150px;
  overflow: hidden;
  background: var(--bg-gray-light);
}

.artist-card-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.artist-card-info {
  padding: 1.5rem;
}

.artist-card-name {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.artist-card-stats {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.artist-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-gray);
}

.artist-stat:last-child {
  border-bottom: none;
}

.artist-card-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-gray);
}

/* Responsive Management Styles */
@media (max-width: 1024px) {
  .management-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .bars-grid {
    grid-template-columns: 1fr;
  }

  .time-slot-form {
    grid-template-columns: 1fr;
  }

  .photo-upload-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }

  .bar-card-actions {
    flex-direction: column;
  }

  .time-slots-actions {
    flex-direction: column;
  }

  .artists-grid {
    grid-template-columns: 1fr;
  }

  .admin-item {
    flex-wrap: wrap;
  }

  .admin-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .invite-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .invite-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 480px) {
  .management-actions {
    justify-content: stretch;
  }

  .add-btn,
  .add-slot-btn {
    width: 100%;
  }

  .photo-upload-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .time-slot-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .remove-slot-btn {
    width: 100%;
  }
}

/* ============================================ */
/* ONBOARDING PAGE STYLES */
/* ============================================ */

.onboarding-page {
  min-height: 100vh;
  background: var(--bg-dark);
  padding: 2rem 1rem;
}

.onboarding-container {
  max-width: 900px;
  margin: 0 auto;
}

.onboarding-header {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem;
  background: var(--bg-card);
  border: 2px solid var(--border-gray);
  border-radius: 16px;
  position: relative;
}

.onboarding-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  border-radius: 16px 16px 0 0;
}

.onboarding-header h1 {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.onboarding-header p {
  color: var(--text-gray);
  font-size: 1.1rem;
}

.bars-created-count {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.5rem 1.5rem;
  background: var(--primary-red);
  color: white;
  border-radius: 20px;
  font-weight: 600;
}

.onboarding-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.onboarding-section {
  background: var(--bg-card);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.onboarding-section:hover {
  border-color: var(--border-red);
}

.onboarding-section .section-title {
  color: var(--text-white);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.section-description {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-grid .input-group.full-width {
  grid-column: 1 / -1;
}

/* Google Places Autocomplete Input Wrapper - Make Full Width */
.onboarding-form .input-group .pac-target-input {
  width: 100% !important;
}

/* Google Places Autocomplete Dropdown Styling */
.pac-container {
  z-index: 10000 !important;
  border-radius: 8px;
  border: 2px solid var(--border-gray);
  background: var(--bg-card);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin-top: 4px;
  font-family: inherit;
  min-width: 400px !important;
  max-width: 600px !important;
  width: auto !important;
}

.pac-item {
  padding: 12px 16px;
  color: var(--text-white);
  border-top: 1px solid var(--border-gray);
  cursor: pointer;
  transition: background 0.2s ease;
  line-height: 1.5;
}

.pac-item:first-child {
  border-top: none;
}

.pac-item:hover {
  background: var(--bg-gray-light);
}

.pac-item-selected {
  background: var(--bg-gray);
}

.pac-icon {
  display: none;
}

.pac-item-query {
  color: var(--text-white);
  font-size: 0.95rem;
  padding-right: 8px;
}

.pac-matched {
  color: var(--primary-red);
  font-weight: 600;
}

.time-slots-preview {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.time-slot-preview-item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr auto;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  align-items: end;
}

.time-slot-remove-wrap {
  display: flex;
  align-items: flex-end;
  padding-bottom: 0.25rem;
}

.time-slot-row .time-slot-remove-wrap .remove-slot-btn {
  white-space: nowrap;
}

.onboarding-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}

.continue-btn {
  padding: 0.75rem 2rem;
  background: var(--primary-red);
  border: none;
  border-radius: 6px;
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.continue-btn:hover {
  background: #dc2626;
  box-shadow: var(--shadow-red);
  transform: translateY(-2px);
}

.bars-created-list {
  margin-top: 2rem;
  padding: 1.5rem;
  background: var(--bg-card);
  border: 2px solid var(--border-gray);
  border-radius: 12px;
}

.bars-created-list h3 {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.bar-created-item {
  color: var(--text-gray);
  padding: 0.5rem 0;
  font-size: 0.95rem;
}

/* Responsive Onboarding Styles */
@media (max-width: 768px) {
  .onboarding-page {
    padding: 1rem 0.5rem;
  }

  .onboarding-header h1 {
    font-size: 1.5rem;
  }

  .onboarding-section {
    padding: 1.5rem;
  }

  .time-slot-preview-item {
    grid-template-columns: 1fr;
  }

  .time-slot-remove-wrap {
    justify-content: flex-end;
  }

  .onboarding-actions {
    flex-direction: column;
  }

  .submit-btn,
  .continue-btn {
    width: 100%;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Onboarding success modal only: direct child of .modal-overlay (not .modal-container > .modal-content) */
.modal-overlay > .modal-content {
  background: var(--bg-card);
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid var(--border-gray);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 90%;
  text-align: center;
}

.modal-overlay > .modal-content h2 {
  margin-bottom: 1rem;
  color: var(--text-white);
  font-size: 1.5rem;
}

.modal-overlay > .modal-content p {
  margin-bottom: 2rem;
  color: var(--text-gray);
  font-size: 1.1rem;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.modal-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.modal-btn.primary {
  background: var(--primary-red);
  color: var(--text-white);
}

.modal-btn.primary:hover {
  background: var(--hover-red);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red);
}

.modal-btn.secondary {
  background: var(--bg-gray);
  color: var(--text-white);
  border: 1px solid var(--border-gray);
}

.modal-btn.secondary:hover {
  background: var(--bg-gray-light);
  border-color: var(--primary-red);
  transform: translateY(-2px);
}

/* ============================================ */
/* BAR MANAGEMENT MODAL SPECIFIC STYLES */
/* Dedicated styles to avoid conflicts with Settings modals */
/* ============================================ */

.bar-management-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.bar-management-modal-container {
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
  z-index: 1001;
  max-width: 800px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease;
}

.bar-management-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  border-bottom: 1px solid var(--border-gray);
  position: relative;
}

.bar-management-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  border-radius: 16px 16px 0 0;
}

.bar-management-modal-content {
  padding: 2rem;
}

/* ============================================ */
/* UNSAVED CHANGES BANNER */
/* ============================================ */

.unsaved-changes-banner {
  padding: 12px 16px;
  margin-bottom: 20px;
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.unsaved-changes-banner .warning-icon {
  font-size: 1.2rem;
}

/* ============================================ */
/* DELETED SLOT STYLES */
/* ============================================ */

.time-slot-item.slot-deleted {
  position: relative;
  opacity: 0.5;
}

.time-slot-item.slot-deleted input {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.deleted-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background: rgba(239, 68, 68, 0.95);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.deleted-overlay span {
  font-weight: 600;
}

.undo-btn {
  background: white;
  color: #dc2626;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.undo-btn:hover {
  background: #fee2e2;
  transform: translateY(-1px);
}

/* ============================================ */
/* SAVE BUTTON WITH CHANGES INDICATOR */
/* ============================================ */

.save-btn.has-changes {
  background: linear-gradient(135deg, #dc2626, #991b1b);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
`, "",{"version":3,"sources":["webpack://./client/styles/bar-owner.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;;;EAGE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,+DAA+D;EAC/D,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;AACf;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,oFAAoF;AACpF;EACE,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,UAAU;AACZ;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd;;oCAEkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uCAAuC;EACvC,+CAA+C;EAC/C,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;;EAGE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8BAC4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8BAC4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,cAAc,EAAE,QAAQ;EACxB,8CAA8C;AAChD;;AAEA;EACE,cAAc,EAAE,UAAU;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,cAAc,EAAE,UAAU;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,cAAc,EAAE,QAAQ;EACxB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,6BAA6B;AAC7B;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA,wBAAwB;EACxB;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uCAAuC;IACvC,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,2DAA2D;IAC3D,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;;;IAGE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA,0GAA0G;EAC1G;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA,wFAAwF;EACxF;IACE,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,6FAA6F;EAC7F;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,+FAA+F;EAC/F;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA,mFAAmF;EACnF;IACE,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,wFAAwF;EACxF;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,oCAAoC;EACpC;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;;;IAGE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA,oDAAoD;EACpD;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,uCAAuC;EACvC;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iDAAiD;EACjD;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD,6BAA6B;AAC7B,iDAAiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,qBAAqB;EACrB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;;;;EAIE,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;IAME,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;;;;;;IAME,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iDAAiD;AACjD,+BAA+B;AAC/B,iDAAiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,yFAAyF;AACzF;EACE,4DAA4D;AAC9D;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;;EAEE,OAAO;AACT;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;;;EAGE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;;EAIE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;;;EAGE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD,2BAA2B;AAC3B,iDAAiD;;AAEjD;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;EACxC,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,0GAA0G;AAC1G;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD,yCAAyC;AACzC,6DAA6D;AAC7D,iDAAiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD,2BAA2B;AAC3B,iDAAiD;;AAEjD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD,wBAAwB;AACxB,iDAAiD;;AAEjD;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD,uCAAuC;AACvC,iDAAiD;;AAEjD;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Bar Owner Dashboard Styles */\n.bar-owner-dashboard {\n  padding: 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 1.8rem;\n  padding: 1.2rem 0;\n}\n\n.section-subtitle {\n  color: var(--text-gray);\n  font-size: 1.1rem;\n  margin-top: 0.5rem;\n}\n\n.content-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.placeholder-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 3rem;\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.placeholder-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.placeholder-card h2 {\n  color: var(--text-white);\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.placeholder-card p {\n  color: var(--text-gray);\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n/* Tab Selector */\n.tab-selector {\n  display: flex;\n  justify-content: space-evenly;\n  margin-bottom: 2rem;\n  padding: 0;\n  border-bottom: 2px solid var(--border-gray);\n  width: 100%;\n}\n\n.tab-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1.25rem 2rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: var(--text-gray);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  top: 2px;\n  flex: 1;\n}\n\n.tab-button:hover {\n  color: var(--text-white);\n  background: var(--bg-gray);\n}\n\n.tab-button.active {\n  color: var(--text-white);\n  border-bottom-color: var(--primary-red);\n  background: var(--bg-gray-light);\n}\n\n.tab-icon {\n  font-size: 1.2rem;\n}\n\n.tab-label {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.tab-content {\n  padding: 2rem 0;\n  animation: fadeIn 0.3s ease;\n}\n\n/* Remove top padding for financials pages */\n.tab-content:has(.financials-overall),\n.tab-content:has(.financials-by-artist) {\n  padding-top: 0;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Artists Content */\n.artists-content {\n  padding: 0 1rem;\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 2rem;\n}\n\n.search-bar-container {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n.search-input {\n  width: 100%;\n  padding: 1rem 3rem 1rem 1rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n}\n\n.search-input::placeholder {\n  color: var(--text-gray);\n}\n\n.search-icon {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2rem;\n  color: var(--text-gray);\n  pointer-events: none;\n}\n\n/* Alphabet Filter */\n.alphabet-filter {\n  margin-bottom: 1rem;\n}\n\n.alphabet-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.alphabet-btn {\n  padding: 0.5rem 0.75rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 40px;\n}\n\n.alphabet-btn:hover {\n  background: var(--bg-gray-light);\n  color: var(--text-white);\n  border-color: var(--primary-red);\n}\n\n.alphabet-btn.active {\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-color: var(--primary-red);\n}\n\n/* Results Info */\n.results-info {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.results-count {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* Artists Grid */\n.artists-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  padding-bottom: 2rem;\n}\n\n.artist-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.artist-card:hover {\n  transform: translateY(-4px);\n  border-color: var(--primary-red);\n  box-shadow: 0 8px 25px rgba(220, 38, 38, 0.2);\n}\n\n.artist-photo {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  background: var(--bg-gray-light);\n}\n\n.artist-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.artist-card:hover .artist-photo img {\n  transform: scale(1.05);\n}\n\n.artist-info {\n  padding: 1.5rem;\n}\n\n.artist-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n}\n\n.artist-location,\n.artist-genre {\n  color: var(--text-gray);\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.artist-details {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-gray);\n}\n\n.artist-rating {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.rating-stars {\n  color: #ffd700;\n  font-size: 1rem;\n}\n\n.rating-value {\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.artist-price {\n  color: var(--primary-red);\n  font-weight: 600;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.artist-availability {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n/* No Results */\n.no-results {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-gray);\n}\n\n.no-results-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.no-results h3 {\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n}\n\n.no-results p {\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* Filters Section */\n.filters-section {\n  margin-bottom: 1rem;\n}\n\n.filters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filter-label {\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-select {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n}\n\n.filter-select option {\n  background: var(--bg-gray);\n  color: var(--text-white);\n  padding: 0.5rem;\n}\n\n/* Filter Actions */\n.filter-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.clear-filters-btn {\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  border: 2px solid var(--primary-red);\n  border-radius: 6px;\n  color: var(--primary-red);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.clear-filters-btn:hover {\n  background: var(--primary-red);\n  color: var(--text-white);\n}\n\n/* Show Details Section */\n.show-details-section,\n.artist-source-section,\n.mile-range-section {\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n}\n\n.section-title {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.show-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.input-label {\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.date-input,\n.time-input {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.date-input:focus,\n.time-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n}\n\n.date-input::-webkit-calendar-picker-indicator,\n.time-input::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n\n/* Artist Source Section */\n.artist-source-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.radio-label:hover {\n  color: var(--primary-red);\n}\n\n.radio-input {\n  display: none;\n}\n\n.radio-custom {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-gray);\n  border-radius: 50%;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.radio-input:checked + .radio-custom {\n  border-color: var(--primary-red);\n}\n\n.radio-input:checked + .radio-custom::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  background: var(--primary-red);\n  border-radius: 50%;\n}\n\n.radio-description {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  margin-left: 2.75rem;\n  margin-top: -0.25rem;\n}\n\n/* Cover Badge */\n.cover-specialty {\n  margin-top: 0.5rem;\n}\n\n.cover-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: linear-gradient(45deg, var(--primary-red), #ff6b6b);\n  color: var(--text-white);\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Artists Content */\n.artists-content {\n  padding: 1rem;\n}\n\n.artists-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n/* Calendar Section */\n.calendar-section {\n  position: relative;\n  margin-bottom: 3rem;\n  min-height: 420px;\n}\n\n.calendar-loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(12, 12, 14, 0.6);\n  backdrop-filter: blur(2px);\n  z-index: 5;\n  border-radius: 16px;\n  pointer-events: all;\n}\n\n.calendar-loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: rgba(24, 24, 28, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);\n}\n\n.calendar-loading-spinner {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.15);\n  border-top-color: var(--primary-red);\n  border-right-color: rgba(255, 255, 255, 0.35);\n  animation: calendarSpinner 0.9s linear infinite;\n}\n\n.calendar-loading-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n@keyframes calendarSpinner {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.calendar-nav {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 0;\n}\n\n.calendar-nav-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  width: 100%;\n}\n\n.calendar-nav-right {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.add-show-btn {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--primary-red);\n  border-color: var(--primary-red);\n  color: var(--text-white);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.add-show-btn:hover {\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.add-show-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  padding: 1.5rem;\n}\n\n.add-show-modal {\n  position: relative;\n  isolation: isolate;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 520px;\n  box-shadow: var(--shadow-dark), var(--shadow-red);\n  overflow: hidden;\n  animation: addShowModalSlideIn 0.25s ease;\n}\n\n.add-show-modal-busy-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(12, 12, 14, 0.85);\n  backdrop-filter: blur(4px);\n  border-radius: 16px;\n  pointer-events: all;\n}\n\n@keyframes addShowModalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.add-show-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid var(--border-gray);\n  position: relative;\n}\n\n.add-show-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n}\n\n.add-show-modal-header h2 {\n  margin: 0;\n  color: var(--text-white);\n  font-size: 1.35rem;\n  font-weight: 600;\n}\n\n.add-show-modal-close {\n  background: transparent;\n  border: none;\n  color: var(--text-gray);\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.add-show-modal-close:hover {\n  background: var(--bg-gray);\n  color: var(--primary-red);\n}\n\n.add-show-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 1.75rem;\n}\n\n.add-show-form-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n}\n\n.add-show-form-row--single {\n  grid-template-columns: 1fr;\n}\n\n.add-show-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  color: var(--text-gray);\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.add-show-input {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n}\n\n.add-show-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n  box-shadow: var(--shadow-red);\n}\n\n.add-show-input option {\n  background: var(--bg-card);\n  color: var(--text-white);\n}\n\n.add-show-custom-times-row {\n  margin: -0.75rem 0 0;\n}\n\n.add-show-custom-times-toggle {\n  display: inline;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--primary-red);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.add-show-custom-times-toggle:hover:not(:disabled) {\n  color: #ff6b6b;\n}\n\n.add-show-custom-times-toggle:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.add-show-split-pay {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.add-show-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n}\n\n.add-show-toggle-label {\n  color: var(--text-white);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 0.9rem;\n}\n\n.add-show-member-splits {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-left: 0.25rem;\n}\n\n.add-show-split-total {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.add-show-split-total--ok {\n  color: var(--text-gray);\n}\n\n.add-show-split-total--warn {\n  color: #fca5a5;\n}\n\n.add-show-helper {\n  margin: -0.5rem 0 0.5rem;\n  color: var(--primary-red);\n  font-size: 0.85rem;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.add-show-error {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  color: #fca5a5;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n}\n\n.add-show-recurring {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  padding: 0.5rem 0;\n}\n\n.add-show-recurring-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-left: 2px solid var(--border-gray);\n  padding-left: 0.75rem;\n  margin-left: 0.1rem;\n}\n\n.add-show-recurring-field {\n  width: 100%;\n  max-width: none;\n  text-transform: uppercase;\n}\n\n.add-show-recurring-field .add-show-input {\n  margin-top: 0.35rem;\n}\n\n.add-show-weekday-heading {\n  display: block;\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.5rem;\n}\n\n.add-show-weekday-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.add-show-weekday-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.55rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-gray);\n  transition: border-color 0.2s ease, color 0.2s ease;\n}\n\n.add-show-weekday-chip:hover {\n  border-color: var(--border-red);\n  color: var(--text-white);\n}\n\n.add-show-weekday-chip input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--primary-red);\n  cursor: pointer;\n  margin: 0;\n}\n\n.add-show-weekday-chip--on {\n  border-color: var(--primary-red);\n  color: var(--text-white);\n}\n\n.add-show-recurrence-summary {\n  margin: 0;\n  font-size: 0.88rem;\n  color: var(--text-gray);\n  line-height: 1.45;\n}\n\n.add-show-recurrence-summary--warn {\n  color: #fca5a5;\n}\n\n.add-show-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.add-show-cancel-btn,\n.add-show-submit-btn {\n  padding: 0.75rem 1.75rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-show-cancel-btn {\n  background: transparent;\n  border: 1px solid var(--border-gray);\n  color: var(--text-gray);\n}\n\n.add-show-cancel-btn:hover {\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.add-show-submit-btn {\n  background: var(--primary-red);\n  border: none;\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.add-show-submit-btn:hover {\n  background: #dc2626;\n}\n\n.add-show-cancel-btn:disabled,\n.add-show-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n.calendar-month-display {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-align: center;\n  flex-shrink: 0;\n  min-width: 250px;\n}\n\n.nav-btn-group {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.month-btn {\n  padding: 0.75rem 2rem;\n}\n\n.nav-btn {\n  padding: 0.75rem 1.5rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  background: var(--bg-card);\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.nav-btn:hover {\n  border-color: var(--border-red);\n  color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.week-btn {\n  background: var(--bg-gray);\n}\n\n.day-btn {\n  background: var(--bg-card);\n}\n\n/* Week Calendar (for Dashboard) */\n.week-calendar {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  margin: 0;\n}\n\n.week-calendar .calendar-day {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 0;\n  flex: 1;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 500px;\n}\n\n.week-calendar .calendar-day:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.week-calendar .calendar-day.today {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.week-calendar .calendar-day.today::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.week-calendar .day-header {\n  padding: 1rem;\n  text-align: center;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n}\n\n.week-calendar .day-name {\n  color: var(--text-gray);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0.25rem;\n}\n\n.week-calendar .day-number {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.week-calendar .day-shows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  flex: 1;\n}\n\n.week-calendar .show-slot {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  padding: 0.75rem;\n  transition: all 0.3s ease;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.week-calendar .show-slot.has-show {\n  background: var(--bg-gray);\n  border-color: rgba(250, 82, 82, 0.45);\n  box-shadow: 0 8px 20px rgba(250, 82, 82, 0.12);\n}\n\n.week-calendar .show-slot.no-show {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.08);\n  opacity: 0.75;\n}\n\n.week-calendar .show-slot.no-show .slot-title,\n.week-calendar .show-slot.no-show .slot-subtitle,\n.week-calendar .show-slot.no-show .slot-content {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.week-calendar .show-slot:hover {\n  border-color: var(--border-red);\n  background: var(--bg-gray-light);\n}\n\n.week-calendar .slot-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  text-align: center;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.week-calendar .slot-title {\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.week-calendar .slot-subtitle {\n  color: var(--text-gray);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.week-calendar .slot-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n}\n\n.week-calendar .slot-content.empty {\n  opacity: 0.5;\n}\n\n/* Pending show indicators (inner content only; outer matches .show-slot.has-show) */\n.slot-content.booked.pending {\n  border-style: dashed;\n  opacity: 0.8;\n  border-color: rgba(250, 82, 82, 0.5);\n}\n\n.slot-content.booked.pending:hover {\n  opacity: 1;\n  border-color: rgba(250, 82, 82, 0.8);\n}\n\n.pending-badge {\n  display: inline-block;\n  background: rgba(250, 82, 82, 0.2);\n  color: var(--primary-red);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-left: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.artist-name.pending {\n  opacity: 0.8;\n}\n\n.week-calendar .no-show-text {\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-style: italic;\n  text-align: center;\n}\n\n/* Weekday Headers (for Month Calendar) */\n.calendar-weekday-headers {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  padding: 0 0.25rem;\n}\n\n.weekday-header {\n  text-align: center;\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 0.5rem;\n}\n\n/* Month Calendar Grid */\n.month-calendar {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.5rem;\n  width: 100%;\n  margin: 0;\n}\n\n.calendar-day-cell {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  padding: 0.5rem;\n  min-height: 120px;\n  transition: all 0.3s ease;\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.calendar-day-cell:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-2px);\n}\n\n.calendar-day-cell.today {\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n  box-shadow: var(--shadow-red);\n}\n\n.calendar-day-cell.today::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--gradient-red);\n  border-radius: 8px 8px 0 0;\n}\n\n.calendar-day-cell.other-month {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.calendar-day-cell.other-month:hover {\n  border-color: var(--border-gray);\n  box-shadow: none;\n  transform: none;\n}\n\n.calendar-day-cell .day-header {\n  padding: 0;\n  text-align: right;\n  border-bottom: none;\n  background: transparent;\n  margin-bottom: 0.25rem;\n}\n\n.calendar-day-cell .day-number {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.calendar-day-cell .day-shows {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n  padding: 0;\n}\n\n/* Bar owner month grid: compact indicators (shown only on mobile via media queries) */\n.calendar-day-mobile-summary {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n  margin-top: 0.15rem;\n}\n\n.calendar-day-has-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  flex-shrink: 0;\n  box-shadow: 0 0 6px rgba(255, 0, 51, 0.35);\n}\n\n.calendar-day-show-count {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--text-white);\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.calendar-day-pending-indicator {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(255, 210, 120, 1);\n  flex-shrink: 0;\n  box-shadow:\n    0 0 0 1px rgba(255, 170, 60, 0.65),\n    0 0 8px rgba(255, 200, 80, 0.35);\n}\n\n/* Compact Show Slots (for Month Calendar) */\n.show-slot-compact {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 4px;\n  padding: 0.3rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.3rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.show-slot-compact:hover {\n  background: var(--bg-gray-light);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-1px);\n}\n\n.show-slot-compact.has-show {\n  border-color: rgba(250, 82, 82, 0.45);\n  box-shadow: 0 6px 16px rgba(250, 82, 82, 0.12);\n}\n\n.show-slot-compact.no-show {\n  background: rgba(255, 255, 255, 0.02);\n  border-color: rgba(255, 255, 255, 0.08);\n  opacity: 0.75;\n}\n\n.show-slot-compact.no-show .artist-name {\n  color: rgba(255, 255, 255, 0.65);\n  font-style: italic;\n}\n\n.show-slot-compact:focus,\n.show-slot-compact:focus-visible {\n  outline: none;\n  border-color: var(--border-red);\n  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.25);\n}\n\n.slot-compact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  width: 100%;\n}\n\n.slot-label-compact {\n  color: var(--text-white);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.65rem;\n  letter-spacing: 0.5px;\n}\n\n.slot-time-compact {\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.artist-name {\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 0.72rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Show Card Modal */\n.show-card-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.82);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(6px);\n  z-index: 1100;\n  padding: 1.5rem;\n}\n\n.show-card-modal {\n  width: 100%;\n  max-width: 560px;\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n  animation: showCardModalFade 0.25s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.show-card-modal-form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n@keyframes showCardModalFade {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.show-card-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n}\n\n.show-card-modal-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.show-card-modal-message,\n.show-card-modal-close {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.75);\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  font-size: 1.4rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.show-card-modal-message:hover,\n.show-card-modal-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.show-card-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n}\n\n.show-card-modal-header-content h2 {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--text-white);\n  letter-spacing: 0.5px;\n}\n\n.show-card-modal-venue {\n  margin: 0.4rem 0 0;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.95rem;\n  letter-spacing: 0.4px;\n}\n\n.show-card-modal-close {\n  font-size: 1.75rem;\n}\n\n.show-card-modal-body {\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n  position: relative;\n}\n\n.show-card-modal-body--loading {\n  min-height: 280px;\n  align-items: center;\n  justify-content: center;\n}\n\n.show-card-modal-artist {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.show-card-modal-image-wrapper {\n  width: 110px;\n  height: 110px;\n  border-radius: 18px;\n  overflow: hidden;\n  border: 2px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n\n.show-card-modal-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.show-card-modal-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.show-card-modal-info-item .label {\n  display: block;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: rgba(255, 255, 255, 0.55);\n  margin-bottom: 0.35rem;\n}\n\n.show-card-modal-input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.show-card-modal-input:focus {\n  outline: none;\n  border-color: rgba(250, 82, 82, 0.6);\n  box-shadow: 0 0 0 2px rgba(250, 82, 82, 0.15);\n}\n\n.show-card-modal-input[disabled] {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.show-card-modal-time-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.show-card-modal-time-row .show-card-modal-info-item {\n  flex: 1;\n  min-width: 140px;\n}\n\n.show-card-modal-info-item .value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.show-card-modal-statistics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.show-card-modal-stat {\n  padding: 1.1rem 1.25rem;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.show-card-modal-input-wrapper {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.currency-prefix {\n  padding: 0.6rem 0.8rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.04);\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.show-card-modal-input-wrapper .show-card-modal-input {\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  padding-left: 0.6rem;\n}\n\n.show-card-modal-input-wrapper .show-card-modal-input:focus {\n  box-shadow: none;\n}\n\n.value--muted {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.55);\n  font-weight: 500;\n}\n\n.show-card-modal-stat .label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.6);\n  letter-spacing: 0.4px;\n}\n\n.show-card-modal-stat .value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-white);\n}\n\n.show-card-modal-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.show-card-modal-loading--centered {\n  min-height: 160px;\n  justify-content: center;\n}\n\n.show-card-modal-loading .spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-top-color: var(--primary-red);\n  animation: showCardSpinner 0.75s linear infinite;\n}\n\n@keyframes showCardSpinner {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.show-card-modal-error {\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(250, 82, 82, 0.4);\n  color: rgba(255, 155, 155, 0.9);\n  background: rgba(250, 82, 82, 0.15);\n}\n\n.show-card-modal-success {\n  padding: 0.85rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(74, 222, 128, 0.35);\n  color: rgba(187, 247, 208, 0.9);\n  background: rgba(34, 197, 94, 0.15);\n}\n\n.show-card-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1.25rem 1.75rem 1.5rem 1.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  gap: 0.75rem;\n  background: transparent;\n}\n\n.show-card-modal-primary-btn,\n.show-card-modal-secondary-btn,\n.show-card-modal-danger-btn {\n  border: none;\n  padding: 0.7rem 1.8rem;\n  border-radius: 999px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease, transform 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.show-card-modal-primary-btn {\n  background: var(--primary-red);\n  color: var(--text-white);\n}\n\n.show-card-modal-primary-btn:hover:enabled {\n  box-shadow: var(--shadow-red);\n  transform: translateY(-1px);\n}\n\n.show-card-modal-secondary-btn {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.show-card-modal-secondary-btn:hover:enabled {\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n  transform: translateY(-1px);\n}\n\n.show-card-modal-danger-btn {\n  background: rgba(250, 82, 82, 0.12);\n  color: rgba(255, 135, 135, 0.9);\n  border: 1px solid rgba(250, 82, 82, 0.35);\n}\n\n.show-card-modal-danger-btn:hover:enabled {\n  background: rgba(250, 82, 82, 0.2);\n  color: rgba(255, 155, 155, 0.95);\n  box-shadow: 0 12px 24px rgba(250, 82, 82, 0.25);\n  transform: translateY(-1px);\n}\n\n.show-card-modal-primary-btn:disabled,\n.show-card-modal-secondary-btn:disabled,\n.show-card-modal-danger-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Confirm Modal */\n.confirm-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.78);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1200;\n  padding: 1.5rem;\n}\n\n.confirm-modal {\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  width: 100%;\n  max-width: 420px;\n  overflow: hidden;\n  animation: showCardModalFade 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.confirm-modal-header {\n  padding: 1.25rem 1.75rem 0.75rem;\n}\n\n.confirm-modal-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: var(--text-white);\n}\n\n.confirm-modal-body {\n  padding: 0 1.75rem 1.5rem;\n}\n\n.confirm-modal-body p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.82);\n  line-height: 1.6;\n}\n\n.confirm-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.75rem 1.5rem;\n}\n\n.confirm-modal-secondary-btn,\n.confirm-modal-danger-btn {\n  border: none;\n  padding: 0.65rem 1.6rem;\n  border-radius: 999px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.confirm-modal-secondary-btn {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.confirm-modal-secondary-btn:hover:enabled {\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);\n  transform: translateY(-1px);\n}\n\n.confirm-modal-danger-btn {\n  background: rgba(250, 82, 82, 0.2);\n  color: rgba(255, 155, 155, 0.95);\n  border: 1px solid rgba(250, 82, 82, 0.4);\n}\n\n.confirm-modal-danger-btn:hover:enabled {\n  box-shadow: 0 12px 26px rgba(250, 82, 82, 0.25);\n  transform: translateY(-1px);\n}\n\n.confirm-modal-danger-btn:disabled,\n.confirm-modal-secondary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Financial Section */\n.financial-section {\n  margin-top: 3rem;\n}\n\n.section-title {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 2rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.comparison-section-box {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 1.25rem;\n  margin-bottom: 3rem;\n  margin-top: 0;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.comparison-section-box:first-of-type {\n  margin-top: 3rem;\n}\n\n.comparison-section-box:last-child {\n  margin-bottom: 0;\n}\n\n.comparison-section-box:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.comparison-section-title {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: center;\n}\n\n.section-info-icon[data-tooltip]::before {\n  width: 320px;\n  font-size: 0.9rem;\n}\n\n.financial-grid {\n  display: flex;\n  gap: 1.5rem;\n  width: 100%;\n  margin: 0 0 3rem 0;\n}\n\n.financial-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 300px;\n}\n\n.financial-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financial-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financial-card h3 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.date-range {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 1rem;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.info-icon {\n  font-size: 0.9rem;\n  cursor: help;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  position: relative;\n  display: inline-block;\n}\n\n.card-info-icon {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n}\n\n.section-info-icon {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 10;\n  font-size: 1rem;\n}\n\n.info-icon:hover {\n  opacity: 1;\n}\n\n.info-icon[data-tooltip]::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: normal;\n  width: 280px;\n  max-width: 90vw;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.card-info-icon[data-tooltip]::before {\n  bottom: auto;\n  top: 100%;\n  left: auto;\n  right: 0;\n  transform: none;\n  margin-bottom: 0;\n  margin-top: 0.5rem;\n  width: 280px;\n}\n\n.section-info-icon[data-tooltip]::before {\n  bottom: auto;\n  top: 100%;\n  left: auto;\n  right: 0;\n  transform: none;\n  margin-bottom: 0;\n  margin-top: 0.5rem;\n  width: 320px;\n  font-size: 0.9rem;\n}\n\n.info-icon[data-tooltip]:hover::before {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.info-icon[data-tooltip]::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 0.25rem;\n  border: 6px solid transparent;\n  border-top-color: var(--border-gray);\n  z-index: 1001;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.card-info-icon[data-tooltip]::after,\n.section-info-icon[data-tooltip]::after {\n  bottom: auto;\n  top: 100%;\n  left: auto;\n  right: 1rem;\n  transform: none;\n  margin-bottom: 0;\n  margin-top: 0.25rem;\n  border-top-color: transparent;\n  border-bottom-color: var(--border-gray);\n}\n\n.info-icon[data-tooltip]:hover::after {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.earnings-amount {\n  color: var(--primary-red);\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.earnings-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.earnings-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: auto;\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.time-slot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.time-slot:last-child {\n  border-bottom: none;\n}\n\n.time-slot-divider {\n  height: 1px;\n  background: var(--border-gray);\n  margin: 0.75rem 0;\n  width: 100%;\n}\n\n.time-slot.total {\n  border-top: 2px solid var(--primary-red);\n  padding-top: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.slot-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.slot-amount {\n  color: var(--primary-red);\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.time-slot.total .slot-amount {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n/* Financial Overview Specific Styles */\n.slot-amount.expense {\n  color: #f87171; /* Red */\n  text-shadow: 0 0 10px rgba(248, 113, 113, 0.3);\n}\n\n.slot-amount.sales {\n  color: #4ade80; /* Green */\n  text-shadow: 0 0 10px rgba(74, 222, 128, 0.3);\n}\n\n.slot-amount.profit-positive {\n  color: #4ade80; /* Green */\n  text-shadow: 0 0 10px rgba(74, 222, 128, 0.3);\n}\n\n.slot-amount.profit-negative {\n  color: #f87171; /* Red */\n  text-shadow: 0 0 10px rgba(248, 113, 113, 0.3);\n}\n\n/* Financials Overall */\n.financials-overall {\n  padding: 0 1rem 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* By Artist Financials */\n.financials-by-artist {\n  padding: 0 1rem 2rem 1rem;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.artist-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n  padding: 1.5rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n}\n\n.mode-toggle {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.mode-toggle-btn {\n  padding: 0.75rem 1.5rem;\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mode-toggle-btn:hover {\n  background: var(--bg-gray-light);\n  border-color: var(--border-red);\n}\n\n.mode-toggle-btn.active {\n  background: var(--primary-red);\n  border-color: var(--primary-red);\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.artist-selectors {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.artist-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 200px;\n}\n\n.artist-selector label {\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.artist-dropdown {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.artist-dropdown:hover {\n  border-color: var(--border-red);\n}\n\n.artist-dropdown:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.artist-dropdown option {\n  background: var(--bg-card);\n  color: var(--text-white);\n}\n\n.artist-dropdown option:disabled {\n  color: var(--text-gray);\n  font-style: italic;\n}\n\n/* Financials Page (Dedicated Page) */\n.financials-overall-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.financials-row-container {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 20px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n}\n\n.financials-row-container:hover {\n  border-color: var(--border-red);\n  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);\n}\n\n.comparison-row-title {\n  color: var(--primary-red);\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid var(--primary-red);\n  text-shadow: 0 0 10px rgba(220, 38, 38, 0.3);\n}\n\n.financials-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  width: 100%;\n}\n\n.financials-detail-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  flex: 1 1 calc(33.333% - 1rem);\n  max-width: calc(33.333% - 1rem);\n  display: flex;\n  flex-direction: column;\n  min-height: 300px;\n}\n\n.financials-detail-card.wide {\n  flex: 1 1 100%;\n  max-width: 100%;\n}\n\n.financials-detail-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financials-detail-card.difference::before {\n  background: linear-gradient(90deg, #10b981, #34d399);\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);\n}\n\n.financials-detail-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.financials-detail-card.difference:hover {\n  border-color: #10b981;\n  box-shadow: 0 0 15px rgba(16, 185, 129, 0.3);\n}\n\n.financials-detail-card h3 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.financials-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: auto;\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.financials-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.financials-item:last-child {\n  border-bottom: none;\n}\n\n.financials-item.total {\n  border-top: 2px solid var(--primary-red);\n  padding-top: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.financials-item.artist-name-item {\n  border-bottom: 2px solid var(--primary-red);\n  padding-bottom: 0.75rem;\n  margin-bottom: 0.5rem;\n  justify-content: center;\n}\n\n.artist-name-label {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: center;\n  width: 100%;\n}\n\n.financials-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.financials-amount {\n  color: var(--primary-red);\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.financials-item.total .financials-amount {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.financials-amount.positive {\n  color: #10b981;\n  text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);\n}\n\n.financials-amount.negative {\n  color: #ef4444;\n  text-shadow: 0 0 10px rgba(239, 68, 68, 0.3);\n}\n\n/* Financials Summary Cards */\n.financials-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.summary-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  padding: 1.5rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.summary-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.summary-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.summary-card h4 {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 1rem;\n}\n\n.summary-amount {\n  color: var(--primary-red);\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.summary-change {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.summary-change.positive {\n  color: #10b981;\n}\n\n.summary-change.negative {\n  color: #ef4444;\n}\n\n/* Financials Periods */\n.financials-periods {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.financials-period-card {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 20px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n}\n\n.financials-period-card:hover {\n  border-color: var(--border-red);\n  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);\n}\n\n.period-header {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--border-gray);\n}\n\n.period-header h3 {\n  color: var(--primary-red);\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  margin-bottom: 0.75rem;\n  text-shadow: 0 0 10px rgba(220, 38, 38, 0.3);\n}\n\n.period-summary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.total-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.total-amount {\n  color: var(--primary-red);\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.change-indicator {\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n}\n\n.change-indicator.positive {\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.change-indicator.negative {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.period-comparison {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n}\n\n.period-data {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.period-data h4 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.period-data.difference h4 {\n  color: var(--primary-red);\n}\n\n.slot-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.slot-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n  gap: 0.5rem;\n}\n\n.slot-item:last-child {\n  border-bottom: none;\n}\n\n.slot-item.total {\n  border-top: 2px solid var(--primary-red);\n  padding-top: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.slot-label {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.slot-value {\n  color: var(--primary-red);\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-align: right;\n}\n\n.slot-item.total .slot-value {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n.slot-value.positive {\n  color: #10b981;\n  text-shadow: 0 0 10px rgba(16, 185, 129, 0.3);\n}\n\n.slot-value.negative {\n  color: #ef4444;\n  text-shadow: 0 0 10px rgba(239, 68, 68, 0.3);\n}\n\n.change-badge {\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 0.25rem 0.5rem;\n  border-radius: 8px;\n  white-space: nowrap;\n}\n\n.change-badge.positive {\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.change-badge.negative {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: var(--text-gray);\n}\n\n.no-data-message p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.error-message {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 12px;\n}\n\n.error-message p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n/* By Artists Tab */\n.financials-by-artists-tab {\n  padding: 0;\n}\n\n.financials-single-artist,\n.financials-compare-artists {\n  padding: 0;\n}\n\n.artist-selection-section {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  transition: all 0.3s ease;\n}\n\n.artist-selection-section:hover {\n  border-color: var(--border-red);\n}\n\n.financials-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  padding: 2rem;\n}\n\n.placeholder-message {\n  text-align: center;\n  max-width: 500px;\n}\n\n.placeholder-icon {\n  font-size: 4rem;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.placeholder-message h3 {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.placeholder-message p {\n  color: var(--text-gray);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  box-shadow: var(--shadow-dark), var(--shadow-red);\n  z-index: 1001;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s ease;\n}\n\n/* Modal scrollbar styling */\n.modal-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-container::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n  border-radius: 4px;\n}\n\n.modal-container::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 4px;\n}\n\n.modal-container::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -45%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid var(--border-gray);\n  position: relative;\n}\n\n.modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  border-radius: 16px 16px 0 0;\n}\n\n.modal-title {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.modal-close-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-gray);\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.modal-close-btn:hover {\n  background: var(--bg-gray);\n  color: var(--primary-red);\n}\n\n.modal-content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.modal-show-card {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.modal-show-card:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.modal-show-header {\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-gray-light);\n}\n\n.modal-show-header h3 {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.modal-show-time {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.modal-show-details {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  color: var(--text-gray);\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-value {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.status-booked {\n  color: var(--primary-red);\n  text-shadow: 0 0 10px rgba(255, 0, 51, 0.3);\n}\n\n/* Tablet Responsive Styles */\n@media (max-width: 1024px) {\n  .financials-detail-card {\n    flex: 1 1 calc(50% - 0.75rem);\n    max-width: calc(50% - 0.75rem);\n  }\n\n  .financials-detail-card.wide {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .bar-owner-dashboard {\n    padding: 1rem 0.5rem;\n  }\n\n  /* Tab Selector Mobile */\n  .tab-selector {\n    padding: 0;\n    justify-content: space-evenly;\n  }\n\n  .tab-button {\n    padding: 1rem 1rem;\n    font-size: 0.9rem;\n    flex: 1;\n  }\n\n  .tab-icon {\n    font-size: 1rem;\n  }\n\n  /* Artists Content Mobile */\n  .artists-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 1rem;\n  }\n\n  .artist-photo {\n    height: 150px;\n  }\n\n  .artist-info {\n    padding: 1rem;\n  }\n\n  .search-input {\n    padding: 0.75rem 2.5rem 0.75rem 0.75rem;\n    font-size: 0.9rem;\n  }\n\n  .alphabet-buttons {\n    gap: 0.25rem;\n  }\n\n  .alphabet-btn {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.8rem;\n    min-width: 35px;\n  }\n\n  /* Filters Mobile */\n  .filters-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 0.75rem;\n  }\n\n  .filter-select {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .clear-filters-btn {\n    padding: 0.6rem 1.25rem;\n    font-size: 0.85rem;\n  }\n\n  /* FindCovers Mobile */\n  .show-details-section,\n  .artist-source-section,\n  .mile-range-section {\n    padding: 1rem;\n  }\n\n  .show-details-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .artist-source-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .section-title {\n    font-size: 1rem;\n  }\n\n  .tab-content {\n    padding: 1.5rem 0;\n  }\n\n  .artists-content {\n    padding: 0.5rem;\n  }\n\n  .artists-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .calendar-nav-right {\n    display: none;\n  }\n\n  /* Bar owner surfaces only: stack Add Show above nav; keep nav controls in one row like artist dashboard */\n  .bar-owner-dashboard .calendar-nav {\n    gap: 1rem;\n    flex-direction: column;\n  }\n\n  /* Month on first row (full width); back / forward controls in two equal columns below */\n  .bar-owner-dashboard .calendar-nav-content {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 0.65rem 0.75rem;\n  }\n\n  .bar-owner-dashboard .calendar-month-display {\n    order: -1;\n    flex: 1 1 100%;\n    min-width: 0;\n    width: 100%;\n    letter-spacing: 0.12em;\n    margin: 0;\n    font-size: 1.15rem;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content > .nav-btn-group {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 0.35rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content .nav-btn {\n    padding: 0.55rem 0.45rem;\n    font-size: 0.72rem;\n    letter-spacing: 0.03em;\n    flex: 1 1 auto;\n    min-width: 0;\n    text-transform: uppercase;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content .nav-btn.month-btn {\n    flex: 1 1 auto;\n    padding: 0.55rem 0.85rem;\n    font-size: 0.78rem;\n  }\n\n  .bar-owner-dashboard .add-show-btn {\n    position: static;\n    transform: none;\n    width: 100%;\n  }\n\n  .add-show-form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .add-show-form {\n    padding: 1.5rem;\n  }\n\n  .add-show-recurring {\n    align-items: stretch;\n  }\n\n  .add-show-toggle-row {\n    flex-wrap: wrap;\n  }\n\n  .add-show-weekday-row {\n    gap: 0.4rem;\n  }\n\n  .add-show-weekday-chip {\n    flex: 1 1 calc(14.28% - 0.35rem);\n    min-width: 3.25rem;\n    justify-content: center;\n  }\n\n  .calendar-month-display {\n    font-size: 1.2rem;\n    min-width: auto;\n  }\n\n  .month-btn {\n    padding: 0.5rem 1.5rem;\n    font-size: 0.9rem;\n  }\n\n  /* Week view (dashboard only): stack days vertically — full-width rows, no horizontal strip */\n  .bar-owner-dashboard .week-calendar {\n    flex-direction: column;\n    gap: 0.75rem;\n    overflow-x: visible;\n    width: 100%;\n  }\n\n  .bar-owner-dashboard .week-calendar .calendar-day {\n    width: 100%;\n    min-width: unset;\n    flex: none;\n    min-height: auto;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-header {\n    padding: 0.75rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-number {\n    font-size: 1.25rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-shows {\n    padding: 0.5rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .show-slot {\n    padding: 0.5rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .slot-title {\n    font-size: 0.8rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .slot-subtitle {\n    font-size: 0.65rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .no-show-text {\n    font-size: 0.75rem;\n  }\n\n  /* Month Calendar Mobile Styles */\n  .weekday-header {\n    font-size: 0.75rem;\n    padding: 0.25rem;\n  }\n\n  .month-calendar {\n    gap: 0.25rem;\n  }\n\n  .calendar-day-cell {\n    min-height: 100px;\n    padding: 0.25rem;\n  }\n\n  .calendar-day-cell .day-number {\n    font-size: 0.9rem;\n  }\n\n  .calendar-day-cell .day-shows {\n    gap: 0.2rem;\n  }\n\n  .show-slot-compact {\n    padding: 0.2rem 0.35rem;\n  }\n\n  .slot-label-compact {\n    font-size: 0.6rem;\n  }\n\n  .artist-name {\n    font-size: 0.65rem;\n  }\n\n  /* Bar owner full-month calendar: compact grid + badges; hide inline slots (tap cell → modal) */\n  .bar-owner-dashboard .month-calendar {\n    gap: 0.35rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell {\n    min-height: 3.35rem;\n    padding: 0.35rem 0.28rem;\n    justify-content: flex-start;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell .day-header {\n    margin-bottom: 0;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell .day-number {\n    font-size: 0.85rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell .day-shows {\n    display: none;\n  }\n\n  .bar-owner-dashboard .calendar-day-mobile-summary {\n    display: flex;\n    margin-top: 0.2rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell[role=\"button\"]:focus-visible {\n    outline: 2px solid var(--primary-red);\n    outline-offset: 2px;\n  }\n\n  .bar-owner-dashboard .calendar-day-show-count {\n    font-size: 0.68rem;\n  }\n\n  .financial-grid {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .financial-card {\n    padding: 1.5rem;\n  }\n\n  .earnings-breakdown {\n    gap: 0.5rem;\n  }\n\n  .slot-amount {\n    font-size: 1rem;\n  }\n\n  .time-slot.total .slot-amount {\n    font-size: 1.2rem;\n  }\n\n  /* Financials Page Mobile */\n  .financials-row-container {\n    padding: 1.5rem;\n  }\n\n  .financials-row {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .financials-detail-card {\n    flex: 1 1 100%;\n    max-width: 100%;\n    padding: 1.5rem;\n    min-height: auto;\n  }\n\n  .card-subtitle {\n    font-size: 0.85rem;\n  }\n\n  .financials-breakdown {\n    gap: 0.5rem;\n  }\n\n  .financials-amount {\n    font-size: 1rem;\n  }\n\n  .financials-item.total .financials-amount {\n    font-size: 1.2rem;\n  }\n\n  /* New Financials Components Mobile */\n  .financials-summary-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .summary-card {\n    padding: 1.25rem;\n  }\n\n  .summary-amount {\n    font-size: 1.5rem;\n  }\n\n  .financials-period-card {\n    padding: 1.5rem;\n  }\n\n  .period-header h3 {\n    font-size: 1.1rem;\n  }\n\n  .period-comparison {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .period-data {\n    padding: 1.25rem;\n  }\n\n  .total-amount {\n    font-size: 1.2rem;\n  }\n\n  .artist-name-label {\n    font-size: 1rem;\n  }\n\n  .artist-selection-section {\n    padding: 1rem;\n  }\n\n  .placeholder-message h3 {\n    font-size: 1.2rem;\n  }\n\n  .placeholder-message p {\n    font-size: 0.9rem;\n  }\n\n  .placeholder-icon {\n    font-size: 3rem;\n  }\n\n  /* Modal Responsive */\n  .modal-container {\n    width: 95%;\n    max-height: 85vh;\n  }\n\n  /* Bar owner Calendar day-detail modal: respect visible viewport on mobile Safari */\n  .bar-owner-dashboard .modal-container.calendar-day-detail-modal {\n    max-height: 80vh;\n    max-height: 80dvh;\n    width: min(640px, 95vw);\n  }\n\n  .bar-owner-dashboard .calendar-day-detail-modal .modal-content {\n    margin: 0 auto;\n    width: 100%;\n    max-width: 640px;\n    align-items: center;\n  }\n\n  .bar-owner-dashboard .calendar-day-detail-modal .modal-show-card {\n    width: 100%;\n    max-width: 560px;\n  }\n\n  .modal-header {\n    padding: 1.5rem;\n  }\n\n  .modal-title {\n    font-size: 1.2rem;\n  }\n\n  .modal-content {\n    padding: 1.5rem;\n    gap: 1rem;\n  }\n\n  .modal-show-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .modal-show-details {\n    padding: 1rem;\n  }\n\n  /* Bar admin Management: prevent wide tables/lists from forcing horizontal page scroll */\n  .bar-owner-dashboard .management-content {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .bar-owner-dashboard .management-section {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Tab Selector Extra Small Mobile */\n  .tab-selector {\n    padding: 0;\n  }\n\n  .tab-button {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.85rem;\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .tab-icon {\n    font-size: 0.9rem;\n  }\n\n  /* Artists Content Extra Small Mobile */\n  .artists-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .artist-photo {\n    height: 120px;\n  }\n\n  .artist-info {\n    padding: 0.75rem;\n  }\n\n  .artist-name {\n    font-size: 1rem;\n  }\n\n  .search-input {\n    padding: 0.5rem 2rem 0.5rem 0.5rem;\n    font-size: 0.85rem;\n  }\n\n  .alphabet-buttons {\n    gap: 0.2rem;\n  }\n\n  .alphabet-btn {\n    padding: 0.3rem 0.4rem;\n    font-size: 0.75rem;\n    min-width: 30px;\n  }\n\n  /* Filters Extra Small Mobile */\n  .filters-grid {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .filter-select {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.8rem;\n  }\n\n  .filter-label {\n    font-size: 0.8rem;\n  }\n\n  .clear-filters-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.8rem;\n  }\n\n  /* FindCovers Extra Small Mobile */\n  .show-details-section,\n  .artist-source-section,\n  .mile-range-section {\n    padding: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .date-input,\n  .time-input {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .radio-label {\n    font-size: 0.9rem;\n  }\n\n  .radio-description {\n    font-size: 0.8rem;\n  }\n\n  .cover-badge {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.6rem;\n  }\n\n  .tab-label {\n    font-size: 0.85rem;\n  }\n\n  .tab-content {\n    padding: 1rem 0;\n  }\n\n  .artists-content {\n    padding: 0.25rem;\n  }\n\n  .bar-owner-dashboard .calendar-nav {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 0.5rem 0.6rem;\n  }\n\n  .bar-owner-dashboard .calendar-month-display {\n    order: -1;\n    flex: 1 1 100%;\n    min-width: 0;\n    width: 100%;\n    letter-spacing: 0.1em;\n    font-size: 1rem;\n    margin: 0;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content > .nav-btn-group {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 0.3rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content .nav-btn {\n    padding: 0.5rem 0.35rem;\n    font-size: 0.68rem;\n    letter-spacing: 0.02em;\n    flex: 1 1 auto;\n    min-width: 0;\n    text-transform: uppercase;\n  }\n\n  .bar-owner-dashboard .calendar-nav-content .nav-btn.month-btn {\n    padding: 0.5rem 0.65rem;\n    font-size: 0.75rem;\n  }\n\n  .bar-owner-dashboard .add-show-btn {\n    width: 100%;\n  }\n\n  .month-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  /* Week view (dashboard): stacked days, full width */\n  .bar-owner-dashboard .week-calendar {\n    flex-direction: column;\n    gap: 0.5rem;\n    overflow-x: visible;\n    width: 100%;\n    padding-bottom: 0.5rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .calendar-day {\n    width: 100%;\n    min-width: unset;\n    flex: none;\n    min-height: auto;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-header {\n    padding: 0.5rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-name {\n    font-size: 0.65rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-number {\n    font-size: 1rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .day-shows {\n    padding: 0.5rem;\n    gap: 0.25rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .show-slot {\n    padding: 0.5rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .slot-title {\n    font-size: 0.75rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .slot-subtitle {\n    font-size: 0.6rem;\n  }\n\n  .bar-owner-dashboard .week-calendar .no-show-text {\n    font-size: 0.7rem;\n  }\n\n  /* Month Calendar Extra Small Mobile */\n  .weekday-header {\n    font-size: 0.65rem;\n    padding: 0.2rem;\n  }\n\n  .month-calendar {\n    gap: 0.2rem;\n  }\n\n  .calendar-day-cell {\n    min-height: 85px;\n    padding: 0.2rem;\n  }\n\n  .calendar-day-cell .day-number {\n    font-size: 0.8rem;\n  }\n\n  .calendar-day-cell .day-shows {\n    gap: 0.15rem;\n  }\n\n  .show-slot-compact {\n    padding: 0.15rem 0.3rem;\n  }\n\n  .slot-label-compact {\n    font-size: 0.55rem;\n  }\n\n  .artist-name {\n    font-size: 0.6rem;\n  }\n\n  .bar-owner-dashboard .month-calendar {\n    gap: 0.28rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell {\n    min-height: 3rem;\n    padding: 0.28rem 0.22rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-cell .day-number {\n    font-size: 0.78rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-show-count {\n    font-size: 0.62rem;\n  }\n\n  .bar-owner-dashboard .calendar-day-has-dot,\n  .bar-owner-dashboard .calendar-day-pending-indicator {\n    width: 6px;\n    height: 6px;\n  }\n\n  .financial-grid {\n    flex-direction: column;\n  }\n\n  .earnings-breakdown {\n    gap: 0.5rem;\n  }\n\n  .time-slot {\n    padding: 0.25rem 0;\n  }\n\n  .slot-label {\n    font-size: 0.8rem;\n  }\n\n  .slot-amount {\n    font-size: 0.9rem;\n  }\n\n  .time-slot.total .slot-amount {\n    font-size: 1.1rem;\n  }\n\n  /* Financials Page Extra Small Mobile */\n  .financials-overall-tab {\n    gap: 1.5rem;\n  }\n\n  .financials-row-container {\n    padding: 1rem;\n  }\n\n  .financials-row {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .financials-detail-card {\n    flex: 1 1 100%;\n    max-width: 100%;\n    padding: 1rem;\n    min-height: auto;\n  }\n\n  .financials-detail-card h3 {\n    font-size: 1rem;\n  }\n\n  .card-subtitle {\n    font-size: 0.8rem;\n  }\n\n  .financials-breakdown {\n    gap: 0.5rem;\n  }\n\n  .financials-item {\n    padding: 0.25rem 0;\n  }\n\n  .financials-label {\n    font-size: 0.8rem;\n  }\n\n  .artist-name-label {\n    font-size: 0.95rem;\n  }\n\n  .financials-amount {\n    font-size: 0.9rem;\n  }\n\n  .financials-item.total .financials-amount {\n    font-size: 1.1rem;\n  }\n\n  /* New Financials Components Extra Small Mobile */\n  .financials-summary-cards {\n    gap: 0.75rem;\n  }\n\n  .summary-card {\n    padding: 1rem;\n  }\n\n  .summary-card h4 {\n    font-size: 0.85rem;\n  }\n\n  .summary-amount {\n    font-size: 1.25rem;\n  }\n\n  .summary-change {\n    font-size: 0.8rem;\n  }\n\n  .financials-period-card {\n    padding: 1rem;\n  }\n\n  .period-header {\n    margin-bottom: 1rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .period-header h3 {\n    font-size: 1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .period-summary {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .total-label {\n    font-size: 0.8rem;\n  }\n\n  .total-amount {\n    font-size: 1.1rem;\n  }\n\n  .change-indicator {\n    font-size: 0.85rem;\n    padding: 0.2rem 0.5rem;\n  }\n\n  .period-comparison {\n    gap: 0.75rem;\n  }\n\n  .period-data {\n    padding: 1rem;\n  }\n\n  .period-data h4 {\n    font-size: 0.95rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .slot-breakdown {\n    gap: 0.5rem;\n  }\n\n  .slot-item {\n    padding: 0.4rem 0;\n  }\n\n  .slot-label {\n    font-size: 0.8rem;\n  }\n\n  .slot-value {\n    font-size: 0.95rem;\n  }\n\n  .slot-item.total .slot-value {\n    font-size: 1.1rem;\n  }\n\n  .change-badge {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.4rem;\n  }\n\n  .artist-selection-section {\n    padding: 0.75rem;\n  }\n\n  .placeholder-message h3 {\n    font-size: 1rem;\n  }\n\n  .placeholder-message p {\n    font-size: 0.85rem;\n  }\n\n  .placeholder-icon {\n    font-size: 2.5rem;\n  }\n\n  .financials-placeholder {\n    min-height: 300px;\n  }\n\n  /* Modal Extra Small */\n  .modal-header {\n    padding: 1rem;\n  }\n\n  .modal-title {\n    font-size: 1rem;\n  }\n\n  .modal-content {\n    padding: 1rem;\n  }\n\n  .modal-show-header h3 {\n    font-size: 1rem;\n  }\n\n  .modal-show-time {\n    font-size: 0.8rem;\n  }\n}\n\n/* ============================================ */\n/* SETTINGS SPECIFIC STYLES */\n/* ============================================ */\n\n.settings-content {\n  padding: 0 1rem;\n}\n\n.settings-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.settings-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n}\n\n.settings-card:hover {\n  border-color: var(--border-red);\n  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);\n}\n\n.settings-card.danger-card {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.settings-card.danger-card:hover {\n  border-color: #dc2626;\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.2);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.card-header h3 {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.settings-input,\n.settings-select,\n.settings-textarea {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.settings-input:focus,\n.settings-select:focus,\n.settings-textarea:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: var(--bg-card);\n}\n\n.settings-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.settings-textarea {\n  resize: vertical;\n  min-height: 120px;\n  font-family: inherit;\n}\n\n.settings-select {\n  cursor: pointer;\n}\n\n.settings-select option {\n  background: var(--bg-gray);\n  color: var(--text-white);\n}\n\n.edit-btn,\n.action-btn,\n.save-btn,\n.submit-btn {\n  padding: 0.75rem 1.5rem;\n  background: var(--primary-red);\n  border: none;\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.edit-btn:hover,\n.action-btn:hover,\n.save-btn:hover,\n.submit-btn:hover {\n  background: #dc2626;\n  box-shadow: var(--shadow-red);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.danger-btn {\n  padding: 0.75rem 1.5rem;\n  background: #ef4444;\n  border: none;\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.danger-btn:hover {\n  background: #dc2626;\n  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);\n}\n\n.cancel-btn {\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cancel-btn:hover {\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.password-info {\n  color: var(--text-gray);\n  line-height: 1.6;\n}\n\n.password-info p {\n  margin-bottom: 0.5rem;\n}\n\n.text-muted {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n}\n\n/* Danger Zone Styles */\n.danger-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.danger-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 8px;\n}\n\n.danger-info h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.danger-info p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Notification Preferences Styles */\n.preferences-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.preference-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.preference-item:hover {\n  border-color: var(--border-red);\n  background: var(--bg-card);\n}\n\n.preference-info h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.preference-info p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Toggle Switch Styles */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--border-gray);\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: var(--primary-red);\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n/* Support Form Styles */\n.support-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.help-links {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.help-item {\n  padding: 1rem;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.help-item:hover {\n  border-color: var(--border-red);\n  background: var(--bg-card);\n}\n\n.help-item h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.help-item p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.help-link {\n  color: var(--primary-red);\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.help-link:hover {\n  color: #dc2626;\n  text-decoration: underline;\n}\n\n/* Privacy & Security Styles */\n.privacy-content,\n.rights-content,\n.cookie-content,\n.contact-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  color: var(--text-gray);\n  line-height: 1.6;\n}\n\n.privacy-item {\n  padding: 1rem;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n}\n\n.privacy-item h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.privacy-item p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.right-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  gap: 1rem;\n}\n\n.right-info {\n  flex: 1;\n}\n\n.right-info h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.right-info p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.right-item .action-btn {\n  flex-shrink: 0;\n}\n\n.cookie-content ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.cookie-content li {\n  margin-bottom: 0.5rem;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.contact-item {\n  color: var(--text-white);\n  font-size: 0.9rem;\n}\n\n.contact-item strong {\n  color: var(--primary-red);\n  margin-right: 0.5rem;\n}\n\n/* Modal Actions for Settings */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.modal-content ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n  color: var(--text-gray);\n}\n\n.modal-content li {\n  margin-bottom: 0.5rem;\n}\n\n/* Responsive Styles for Settings */\n@media (max-width: 768px) {\n  .settings-content {\n    padding: 0 0.5rem;\n  }\n\n  .settings-card {\n    padding: 1.5rem;\n  }\n\n  .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .danger-item,\n  .right-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .help-links {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .edit-btn,\n  .action-btn,\n  .save-btn,\n  .submit-btn,\n  .danger-btn,\n  .cancel-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .settings-card {\n    padding: 1rem;\n  }\n\n  .card-header h3 {\n    font-size: 1rem;\n  }\n\n  .settings-input,\n  .settings-select,\n  .settings-textarea {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .edit-btn,\n  .action-btn,\n  .save-btn,\n  .submit-btn,\n  .danger-btn,\n  .cancel-btn {\n    padding: 0.6rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .preference-item {\n    padding: 0.75rem;\n  }\n\n  .preference-info h4 {\n    font-size: 0.9rem;\n  }\n\n  .preference-info p {\n    font-size: 0.85rem;\n  }\n\n  .help-item {\n    padding: 0.75rem;\n  }\n\n  .help-item h4 {\n    font-size: 0.9rem;\n  }\n\n  .help-item p {\n    font-size: 0.85rem;\n  }\n}\n\n/* ============================================ */\n/* MANAGEMENT SPECIFIC STYLES */\n/* ============================================ */\n\n.management-content {\n  padding: 0 1rem;\n}\n\n.management-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.management-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1.5rem;\n}\n\n.add-btn,\n.add-slot-btn {\n  padding: 0.75rem 1.5rem;\n  background: var(--primary-red);\n  border: none;\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.add-btn:hover,\n.add-slot-btn:hover {\n  background: #dc2626;\n  box-shadow: var(--shadow-red);\n}\n\n/* Bar Cards Grid */\n.bars-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n/* Artist cards (Find / My / Covers): narrower columns, taller photo, tighter name band */\n.bars-grid.bars-grid--artists {\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n.bar-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.bar-card:hover {\n  border-color: var(--border-red);\n  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);\n}\n\n.bar-card-photos {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  background: var(--bg-gray-light);\n}\n\n.bar-card-photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.bar-card-photo-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 4rem;\n}\n\n.bar-card.bar-card--artist {\n  min-width: 0;\n}\n\n.bar-card.bar-card--artist .bar-card-photos {\n  height: 240px;\n}\n\n.bar-card.bar-card--artist .bar-card-content {\n  padding: 0.65rem 1.5rem;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.bar-card.bar-card--artist .bar-card-name {\n  margin: 0;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.bar-card-content {\n  padding: 1.5rem;\n}\n\n.bar-card-name {\n  color: var(--text-white);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.bar-card-address {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.bar-card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-gray);\n}\n\n.bar-detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bar-detail-label {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.bar-detail-value {\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n/* Bar Detail Modal: match Edit Bar modal, prevent horizontal scroll */\n.bar-detail-modal {\n  min-width: 0;\n}\n\n.bar-detail-modal .bar-modal-body,\n.bar-detail-modal.groups-modal-body {\n  overflow-x: hidden;\n  min-width: 0;\n}\n\n.bar-detail-modal .groups-modal-photo-wrapper {\n  width: 180px;\n  height: 180px;\n  flex-shrink: 0;\n  min-width: 180px;\n}\n\n.bar-detail-modal .groups-modal-field-value {\n  min-width: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.bar-detail-time-slots-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.bar-detail-time-slot-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.bar-detail-slot-name {\n  font-weight: 600;\n  color: var(--text-white);\n  font-size: 0.95rem;\n}\n\n.bar-detail-slot-times {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.9rem;\n}\n\n.bar-card-actions {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-gray);\n}\n\n.bar-card-actions .edit-btn,\n.bar-card-actions .danger-btn {\n  flex: 1;\n}\n\n.no-bars-message,\n.no-data-message,\n.no-selection-message {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-gray);\n}\n\n.no-bars-icon,\n.no-data-icon,\n.no-selection-icon {\n  font-size: 4rem;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.no-bars-message h3,\n.no-data-message h3,\n.no-selection-message h3 {\n  color: var(--text-white);\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n/* Bar admin: no venues assigned (shared BarOwnerDashboard) */\n.bar-admin-dashboard-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: min(55vh, 480px);\n  padding: 2rem 1.5rem;\n  max-width: 28rem;\n  margin: 0 auto;\n}\n\n.bar-admin-dashboard-empty h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: var(--text-white);\n  line-height: 1.4;\n}\n\n.bar-admin-dashboard-empty p {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.bar-admin-dashboard-empty p + p {\n  margin-top: 0.75rem;\n}\n\n.bar-admin-dashboard-email {\n  font-weight: 600;\n  word-break: break-word;\n  color: var(--text-white) !important;\n}\n\n/* Photo Upload Styles */\n.photo-upload-section {\n  margin: 1.5rem 0;\n}\n\n.photo-upload-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.use-default-btn {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: 2px solid var(--primary-red);\n  border-radius: 6px;\n  color: var(--primary-red);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.use-default-btn:hover {\n  background: var(--primary-red);\n  color: white;\n}\n\n.photo-upload-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.photo-upload-item {\n  position: relative;\n  width: 100%;\n  padding-top: 75%;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: grab;\n  touch-action: none;\n}\n\n.photo-upload-item:active {\n  cursor: grabbing;\n}\n\n.photo-upload-item img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.photo-remove-btn {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  width: 30px;\n  height: 30px;\n  background: rgba(239, 68, 68, 0.9);\n  border: none;\n  border-radius: 50%;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.photo-remove-btn:hover {\n  background: #dc2626;\n  transform: scale(1.1);\n}\n\n.photo-upload-placeholder {\n  width: 100%;\n  padding-top: 75%;\n  position: relative;\n  background: var(--bg-gray-light);\n  border: 2px dashed var(--border-gray);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.photo-upload-placeholder:hover {\n  border-color: var(--primary-red);\n  background: var(--bg-card);\n}\n\n.photo-upload-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-gray);\n}\n\n.upload-icon {\n  font-size: 2rem;\n}\n\n.photo-upload-hint {\n  color: var(--text-gray);\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n  font-style: italic;\n}\n\n.photo-upload-count {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n  margin-left: auto;\n}\n\n.photo-upload-error {\n  margin-top: 0.5rem;\n}\n\n.photo-upload-loading-bar-wrap {\n  width: 100%;\n  margin-bottom: 0.75rem;\n  background: var(--bg-gray);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.photo-upload-loading-bar {\n  height: 6px;\n  background: var(--primary-red);\n  transition: width 0.2s ease;\n}\n\n.photo-upload-loading-text {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n  margin-bottom: 0;\n}\n\n.photo-upload-drag-handle {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  z-index: 3;\n  cursor: grab;\n  color: var(--text-white);\n  font-size: 0.75rem;\n  padding: 4px 6px;\n  min-width: 24px;\n  min-height: 24px;\n  touch-action: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n}\n\n.photo-upload-drag-handle:active {\n  cursor: grabbing;\n}\n\n.photo-upload-primary-badge {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  background: var(--primary-red);\n  color: var(--text-white);\n  font-size: 0.65rem;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 600;\n  z-index: 2;\n}\n\n.photo-upload-rejected-badge {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  background: #7f1d1d;\n  color: var(--text-white);\n  font-size: 0.65rem;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 600;\n  z-index: 2;\n}\n\n.photo-upload-item-dragging {\n  opacity: 0.7;\n}\n\n/* Full-screen photo upload progress overlay */\n.photo-upload-progress-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: var(--bg-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: all;\n}\n\n.photo-upload-progress-overlay-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 2rem;\n  max-width: 90vw;\n}\n\n.photo-upload-progress-overlay-spinner {\n  width: 3rem;\n  height: 3rem;\n  border: 3px solid var(--border-gray);\n  border-top-color: var(--primary-red);\n  border-radius: 50%;\n  animation: photo-upload-progress-spin 0.8s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes photo-upload-progress-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.photo-upload-progress-overlay-title {\n  color: var(--text-white);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.photo-upload-progress-overlay-count {\n  color: var(--text-gray);\n  font-size: 1rem;\n  margin: 0;\n}\n\n.photo-upload-progress-overlay-bar {\n  display: flex;\n  gap: 4px;\n  width: 100%;\n  max-width: 320px;\n  min-height: 12px;\n}\n\n.photo-upload-progress-segment {\n  flex: 1;\n  background: var(--bg-gray);\n  border-radius: 4px;\n  transition: background 0.2s ease;\n}\n\n.photo-upload-progress-segment.segment-done,\n.photo-upload-progress-segment.segment-success {\n  background: var(--primary-red);\n}\n\n.photo-upload-progress-segment.segment-rejected {\n  background: #b91c1c;\n}\n\n.photo-upload-progress-overlay-message {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin: 0;\n  text-align: center;\n}\n\n.photo-upload-progress-overlay-cancel {\n  margin-top: 0.5rem;\n  padding: 0.5rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-white);\n  background: transparent;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.photo-upload-progress-overlay-cancel:hover {\n  background: var(--bg-gray);\n  border-color: var(--text-gray);\n}\n\n/* Bar Form Styles */\n.bar-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Time Slot Styles */\n.bar-selector-section {\n  margin-bottom: 2rem;\n}\n\n.bar-selector {\n  width: 100%;\n  max-width: 400px;\n}\n\n.time-slots-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin: 2rem 0;\n}\n\n.time-slot-item {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.time-slot-item:hover {\n  border-color: var(--border-red);\n}\n\n.time-slot-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.time-slot-header h4 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.remove-slot-btn {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: 2px solid #ef4444;\n  border-radius: 6px;\n  color: #ef4444;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.remove-slot-btn:hover {\n  background: #ef4444;\n  color: white;\n}\n\n.time-slot-form {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 1rem;\n}\n\n.time-slots-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin: 2rem 0;\n}\n\n.time-slots-info {\n  background: rgba(220, 38, 38, 0.1);\n  border: 1px solid rgba(220, 38, 38, 0.3);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 2rem;\n}\n\n.time-slots-info .info-text {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* Management Grid Layout (for admins tab) */\n.management-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.management-col-left,\n.management-col-right {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Admin List Styles */\n.admin-list-section,\n.pending-invites-section,\n.invite-admin-form-section {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n/* Invite Admin - User Found container */\n.invite-admin-user-found {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n}\n\n.invite-admin-user-found-title {\n  margin: 0 0 0.75rem 0;\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.invite-admin-user-found-details {\n  display: flex;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  color: var(--text-white);\n}\n\n.invite-admin-user-found-label {\n  font-weight: 600;\n}\n\n.invite-admin-user-found-status {\n  margin: 0.75rem 0 0;\n  padding: 8px 12px;\n  border-radius: 6px;\n}\n\n.invite-admin-user-found-status--valid {\n  background: rgba(16, 185, 129, 0.2);\n  border: 1px solid rgba(16, 185, 129, 0.4);\n  color: #34d399;\n}\n\n.invite-admin-user-found-status--self,\n.invite-admin-user-found-status--wrong_role,\n.invite-admin-user-found-status--already_member,\n.invite-admin-user-found-status--pending {\n  background: rgba(245, 158, 11, 0.15);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: #fbbf24;\n}\n\n.admin-bar-group,\n.artists-bar-group {\n  margin-bottom: 2rem;\n}\n\n.admin-bar-header,\n.artists-bar-header,\n.pending-invites-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid var(--border-gray);\n}\n\n.admin-bar-header h3,\n.artists-bar-header h3,\n.pending-invites-header h3 {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.admin-count,\n.artist-count,\n.invite-count {\n  background: var(--primary-red);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.admins-list,\n.invites-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.admin-item,\n.invite-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-gray-light);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.admin-item:hover,\n.invite-item:hover {\n  border-color: var(--border-red);\n}\n\n.invite-item.expiring-soon {\n  border-color: #f59e0b;\n  background: rgba(245, 158, 11, 0.05);\n}\n\n.admin-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.admin-info {\n  flex: 1;\n}\n\n.admin-name {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.admin-email {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  margin-bottom: 0.25rem;\n}\n\n.admin-date {\n  color: var(--text-gray);\n  font-size: 0.75rem;\n}\n\n.admin-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.no-admins-message,\n.no-invites-message,\n.no-artists-message {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-gray);\n}\n\n/* Invite Styles */\n.invite-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.invite-main {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.invite-icon {\n  font-size: 1.5rem;\n}\n\n.invite-email {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.invite-bar {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n}\n\n.invite-meta {\n  display: flex;\n  gap: 1rem;\n}\n\n.invite-date,\n.invite-expiry {\n  color: var(--text-gray);\n  font-size: 0.75rem;\n}\n\n.invite-expiry.expiring {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.invite-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n/* Invite Form Styles */\n.form-header {\n  margin-bottom: 1.5rem;\n}\n\n.form-header h3 {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.form-header p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n}\n\n.invite-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.input-hint {\n  color: var(--text-gray);\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n  font-style: italic;\n}\n\n.invite-info-box {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: rgba(220, 38, 38, 0.05);\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  border-radius: 8px;\n}\n\n.invite-info-box h4 {\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.invite-info-box p,\n.invite-info-box ul {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  line-height: 1.6;\n  margin: 0.5rem 0;\n}\n\n.invite-info-box ul {\n  padding-left: 1.5rem;\n}\n\n/* Bar Select Styles */\n.bar-select-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.bar-select-btn {\n  padding: 0.5rem 1rem;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bar-select-btn:hover:not(:disabled) {\n  background: var(--bg-card);\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.bar-select-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.bar-select-list {\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  padding: 0.75rem;\n  background: var(--bg-gray-light);\n}\n\n.bar-select-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  cursor: pointer;\n  border-radius: 6px;\n  background: transparent;\n  transition: all 0.3s ease;\n  margin-bottom: 0.5rem;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.bar-select-item:last-child {\n  margin-bottom: 0;\n}\n\n.bar-select-item:hover {\n  background: var(--bg-card);\n}\n\n.bar-select-item.selected {\n  background: rgba(255, 0, 51, 0.1);\n  border: 1px solid rgba(255, 0, 51, 0.3);\n}\n\n.bar-select-item.selected:hover {\n  background: rgba(255, 0, 51, 0.15);\n  border-color: rgba(255, 0, 51, 0.5);\n}\n\n.bar-select-item--cancelling {\n  pointer-events: none;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bar-select-checkbox {\n  margin-right: 0.75rem;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--primary-red);\n  flex-shrink: 0;\n}\n\n.bar-select-checkbox:checked {\n  accent-color: var(--primary-red);\n}\n\n.bar-select-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.bar-select-name {\n  font-weight: 600;\n  color: var(--text-white);\n  font-size: 0.95rem;\n}\n\n.bar-select-address {\n  font-size: 0.8rem;\n  color: var(--text-gray);\n}\n\n/* Artists Grid */\n.artists-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  border-color: var(--border-red);\n}\n\n.stat-icon {\n  font-size: 2.5rem;\n}\n\n.stat-info h4 {\n  color: var(--text-gray);\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.25rem;\n}\n\n.stat-value {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.artists-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.artist-management-card {\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.artist-management-card:hover {\n  border-color: var(--border-red);\n  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.1);\n}\n\n.artist-card-photo {\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n  background: var(--bg-gray-light);\n}\n\n.artist-card-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.artist-card-info {\n  padding: 1.5rem;\n}\n\n.artist-card-name {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.artist-card-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.artist-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.artist-stat:last-child {\n  border-bottom: none;\n}\n\n.artist-card-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-gray);\n}\n\n/* Responsive Management Styles */\n@media (max-width: 1024px) {\n  .management-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .bars-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .time-slot-form {\n    grid-template-columns: 1fr;\n  }\n\n  .photo-upload-grid {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  }\n\n  .bar-card-actions {\n    flex-direction: column;\n  }\n\n  .time-slots-actions {\n    flex-direction: column;\n  }\n\n  .artists-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .admin-item {\n    flex-wrap: wrap;\n  }\n\n  .admin-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .invite-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .invite-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .management-actions {\n    justify-content: stretch;\n  }\n\n  .add-btn,\n  .add-slot-btn {\n    width: 100%;\n  }\n\n  .photo-upload-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n\n  .time-slot-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .remove-slot-btn {\n    width: 100%;\n  }\n}\n\n/* ============================================ */\n/* ONBOARDING PAGE STYLES */\n/* ============================================ */\n\n.onboarding-page {\n  min-height: 100vh;\n  background: var(--bg-dark);\n  padding: 2rem 1rem;\n}\n\n.onboarding-container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.onboarding-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 2rem;\n  background: var(--bg-card);\n  border: 2px solid var(--border-gray);\n  border-radius: 16px;\n  position: relative;\n}\n\n.onboarding-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  border-radius: 16px 16px 0 0;\n}\n\n.onboarding-header h1 {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.onboarding-header p {\n  color: var(--text-gray);\n  font-size: 1.1rem;\n}\n\n.bars-created-count {\n  display: inline-block;\n  margin-top: 1rem;\n  padding: 0.5rem 1.5rem;\n  background: var(--primary-red);\n  color: white;\n  border-radius: 20px;\n  font-weight: 600;\n}\n\n.onboarding-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.onboarding-section {\n  background: var(--bg-card);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n}\n\n.onboarding-section:hover {\n  border-color: var(--border-red);\n}\n\n.onboarding-section .section-title {\n  color: var(--text-white);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.section-description {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-grid .input-group.full-width {\n  grid-column: 1 / -1;\n}\n\n/* Google Places Autocomplete Input Wrapper - Make Full Width */\n.onboarding-form .input-group .pac-target-input {\n  width: 100% !important;\n}\n\n/* Google Places Autocomplete Dropdown Styling */\n.pac-container {\n  z-index: 10000 !important;\n  border-radius: 8px;\n  border: 2px solid var(--border-gray);\n  background: var(--bg-card);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  margin-top: 4px;\n  font-family: inherit;\n  min-width: 400px !important;\n  max-width: 600px !important;\n  width: auto !important;\n}\n\n.pac-item {\n  padding: 12px 16px;\n  color: var(--text-white);\n  border-top: 1px solid var(--border-gray);\n  cursor: pointer;\n  transition: background 0.2s ease;\n  line-height: 1.5;\n}\n\n.pac-item:first-child {\n  border-top: none;\n}\n\n.pac-item:hover {\n  background: var(--bg-gray-light);\n}\n\n.pac-item-selected {\n  background: var(--bg-gray);\n}\n\n.pac-icon {\n  display: none;\n}\n\n.pac-item-query {\n  color: var(--text-white);\n  font-size: 0.95rem;\n  padding-right: 8px;\n}\n\n.pac-matched {\n  color: var(--primary-red);\n  font-weight: 600;\n}\n\n.time-slots-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.time-slot-preview-item {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  align-items: end;\n}\n\n.time-slot-remove-wrap {\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 0.25rem;\n}\n\n.time-slot-row .time-slot-remove-wrap .remove-slot-btn {\n  white-space: nowrap;\n}\n\n.onboarding-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.continue-btn {\n  padding: 0.75rem 2rem;\n  background: var(--primary-red);\n  border: none;\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.continue-btn:hover {\n  background: #dc2626;\n  box-shadow: var(--shadow-red);\n  transform: translateY(-2px);\n}\n\n.bars-created-list {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background: var(--bg-card);\n  border: 2px solid var(--border-gray);\n  border-radius: 12px;\n}\n\n.bars-created-list h3 {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.bar-created-item {\n  color: var(--text-gray);\n  padding: 0.5rem 0;\n  font-size: 0.95rem;\n}\n\n/* Responsive Onboarding Styles */\n@media (max-width: 768px) {\n  .onboarding-page {\n    padding: 1rem 0.5rem;\n  }\n\n  .onboarding-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .onboarding-section {\n    padding: 1.5rem;\n  }\n\n  .time-slot-preview-item {\n    grid-template-columns: 1fr;\n  }\n\n  .time-slot-remove-wrap {\n    justify-content: flex-end;\n  }\n\n  .onboarding-actions {\n    flex-direction: column;\n  }\n\n  .submit-btn,\n  .continue-btn {\n    width: 100%;\n  }\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Onboarding success modal only: direct child of .modal-overlay (not .modal-container > .modal-content) */\n.modal-overlay > .modal-content {\n  background: var(--bg-card);\n  padding: 2rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-gray);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  max-width: 500px;\n  width: 90%;\n  text-align: center;\n}\n\n.modal-overlay > .modal-content h2 {\n  margin-bottom: 1rem;\n  color: var(--text-white);\n  font-size: 1.5rem;\n}\n\n.modal-overlay > .modal-content p {\n  margin-bottom: 2rem;\n  color: var(--text-gray);\n  font-size: 1.1rem;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.modal-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.modal-btn.primary {\n  background: var(--primary-red);\n  color: var(--text-white);\n}\n\n.modal-btn.primary:hover {\n  background: var(--hover-red);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red);\n}\n\n.modal-btn.secondary {\n  background: var(--bg-gray);\n  color: var(--text-white);\n  border: 1px solid var(--border-gray);\n}\n\n.modal-btn.secondary:hover {\n  background: var(--bg-gray-light);\n  border-color: var(--primary-red);\n  transform: translateY(-2px);\n}\n\n/* ============================================ */\n/* BAR MANAGEMENT MODAL SPECIFIC STYLES */\n/* Dedicated styles to avoid conflicts with Settings modals */\n/* ============================================ */\n\n.bar-management-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.bar-management-modal-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);\n  z-index: 1001;\n  max-width: 800px;\n  width: 90%;\n  max-height: 85vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s ease;\n}\n\n.bar-management-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2rem;\n  border-bottom: 1px solid var(--border-gray);\n  position: relative;\n}\n\n.bar-management-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  border-radius: 16px 16px 0 0;\n}\n\n.bar-management-modal-content {\n  padding: 2rem;\n}\n\n/* ============================================ */\n/* UNSAVED CHANGES BANNER */\n/* ============================================ */\n\n.unsaved-changes-banner {\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fbbf24;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.unsaved-changes-banner .warning-icon {\n  font-size: 1.2rem;\n}\n\n/* ============================================ */\n/* DELETED SLOT STYLES */\n/* ============================================ */\n\n.time-slot-item.slot-deleted {\n  position: relative;\n  opacity: 0.5;\n}\n\n.time-slot-item.slot-deleted input {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.deleted-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n  background: rgba(239, 68, 68, 0.95);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.deleted-overlay span {\n  font-weight: 600;\n}\n\n.undo-btn {\n  background: white;\n  color: #dc2626;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.undo-btn:hover {\n  background: #fee2e2;\n  transform: translateY(-1px);\n}\n\n/* ============================================ */\n/* SAVE BUTTON WITH CHANGES INDICATOR */\n/* ============================================ */\n\n.save-btn.has-changes {\n  background: linear-gradient(135deg, #dc2626, #991b1b);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
